import "./cameraEditor.1acb9652.js";
import "./cameraEditor.4b8d4fc8.js";
import "./cameraEditor.737f6996.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("82VHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dbb4439cfbde5f7$export$2e2bcd8739ae039);
var $5dbb4439cfbde5f7$var$Stats = function() {
    var mode = 0;
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
    container.addEventListener('click', function(event) {
        event.preventDefault();
        showPanel(++mode % container.children.length);
    }, false);
    //
    function addPanel(panel) {
        container.appendChild(panel.dom);
        return panel;
    }
    function showPanel(id) {
        for(var i = 0; i < container.children.length; i++)container.children[i].style.display = i === id ? 'block' : 'none';
        mode = id;
    }
    //
    var beginTime = (performance || Date).now(), prevTime = beginTime, frames = 0;
    var fpsPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('FPS', '#0ff', '#002'));
    var msPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('MS', '#0f0', '#020'));
    if (self.performance && self.performance.memory) var memPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('MB', '#f08', '#201'));
    showPanel(0);
    return {
        REVISION: 16,
        dom: container,
        addPanel: addPanel,
        showPanel: showPanel,
        begin: function() {
            beginTime = (performance || Date).now();
        },
        end: function() {
            frames++;
            var time = (performance || Date).now();
            msPanel.update(time - beginTime, 200);
            if (time >= prevTime + 1000) {
                fpsPanel.update(frames * 1000 / (time - prevTime), 100);
                prevTime = time;
                frames = 0;
                if (memPanel) {
                    var memory = performance.memory;
                    memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
                }
            }
            return time;
        },
        update: function() {
            beginTime = this.end();
        },
        // Backwards Compatibility
        domElement: container,
        setMode: showPanel
    };
};
$5dbb4439cfbde5f7$var$Stats.Panel = function(name, fg, bg) {
    var min = Infinity, max = 0, round = Math.round;
    var PR = round(window.devicePixelRatio || 1);
    var WIDTH = 80 * PR, HEIGHT = 48 * PR, TEXT_X = 3 * PR, TEXT_Y = 2 * PR, GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR, GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;
    var canvas = document.createElement('canvas');
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = 'width:80px;height:48px';
    var context = canvas.getContext('2d');
    context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
    context.textBaseline = 'top';
    context.fillStyle = bg;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = fg;
    context.fillText(name, TEXT_X, TEXT_Y);
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    context.fillStyle = bg;
    context.globalAlpha = 0.9;
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    return {
        dom: canvas,
        update: function(value, maxValue) {
            min = Math.min(min, value);
            max = Math.max(max, value);
            context.fillStyle = bg;
            context.globalAlpha = 1;
            context.fillRect(0, 0, WIDTH, GRAPH_Y);
            context.fillStyle = fg;
            context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);
            context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
            context.fillStyle = bg;
            context.globalAlpha = 0.9;
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
        }
    };
};
var $5dbb4439cfbde5f7$export$2e2bcd8739ae039 = $5dbb4439cfbde5f7$var$Stats;

});


var $jw0R5 = parcelRequire("jw0R5");

var $ihXk0 = parcelRequire("ihXk0");

var $jw0R5 = parcelRequire("jw0R5");
// https://github.com/mrdoob/three.js/issues/5552
// http://en.wikipedia.org/wiki/RGBE_image_format
class $e3256e60e1337cbc$export$d076a711b55c758a extends (0, $jw0R5.DataTextureLoader) {
    constructor(manager){
        super(manager);
        this.type = (0, $jw0R5.HalfFloatType);
    }
    // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
    parse(buffer) {
        const /* default error routine.  change this to change error handling */ rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
            switch(rgbe_error_code){
                case rgbe_read_error:
                    throw new Error('THREE.RGBELoader: Read Error: ' + (msg || ''));
                case rgbe_write_error:
                    throw new Error('THREE.RGBELoader: Write Error: ' + (msg || ''));
                case rgbe_format_error:
                    throw new Error('THREE.RGBELoader: Bad File Format: ' + (msg || ''));
                default:
                case rgbe_memory_error:
                    throw new Error('THREE.RGBELoader: Memory Error: ' + (msg || ''));
            }
        }, /* offsets to red, green, and blue components in a data (float) pixel */ //RGBE_DATA_RED = 0,
        //RGBE_DATA_GREEN = 1,
        //RGBE_DATA_BLUE = 2,
        /* number of floats per pixel, use 4 since stored in rgba image format */ //RGBE_DATA_SIZE = 4,
        /* flags indicating which fields in an rgbe_header_info are valid */ RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = '\n', fgets = function(buffer, lineLimit, consume) {
            const chunkSize = 128;
            lineLimit = !lineLimit ? 1024 : lineLimit;
            let p = buffer.pos, i = -1, len = 0, s = '', chunk = String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
            while(0 > (i = chunk.indexOf(NEWLINE)) && len < lineLimit && p < buffer.byteLength){
                s += chunk;
                len += chunk.length;
                p += chunkSize;
                chunk += String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
            }
            if (-1 < i) {
                /*for (i=l-1; i>=0; i--) {
						byteCode = m.charCodeAt(i);
						if (byteCode > 0x7f && byteCode <= 0x7ff) byteLen++;
						else if (byteCode > 0x7ff && byteCode <= 0xffff) byteLen += 2;
						if (byteCode >= 0xDC00 && byteCode <= 0xDFFF) i--; //trail surrogate
					}*/ if (false !== consume) buffer.pos += len + i + 1;
                return s + chunk.slice(0, i);
            }
            return false;
        }, /* minimal header reading.  modify if you want to parse more information */ RGBE_ReadHeader = function(buffer) {
            // regexes to parse header info fields
            const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, // RGBE format header struct
            header = {
                valid: 0,
                /* indicate which fields are valid */ string: '',
                /* the actual header string */ comments: '',
                /* comments found in header */ programtype: 'RGBE',
                /* listed at beginning of file to identify it after "#?". defaults to "RGBE" */ format: '',
                /* RGBE format, default 32-bit_rle_rgbe */ gamma: 1.0,
                /* image has already been gamma corrected with given gamma. defaults to 1.0 (no correction) */ exposure: 1.0,
                /* a value of 1.0 in an image corresponds to <exposure> watts/steradian/m^2. defaults to 1.0 */ width: 0,
                height: 0 /* image dimensions, width/height */ 
            };
            let line, match;
            if (buffer.pos >= buffer.byteLength || !(line = fgets(buffer))) rgbe_error(rgbe_read_error, 'no header found');
            /* if you want to require the magic token then uncomment the next line */ if (!(match = line.match(magic_token_re))) rgbe_error(rgbe_format_error, 'bad initial token');
            header.valid |= RGBE_VALID_PROGRAMTYPE;
            header.programtype = match[1];
            header.string += line + '\n';
            while(true){
                line = fgets(buffer);
                if (false === line) break;
                header.string += line + '\n';
                if ('#' === line.charAt(0)) {
                    header.comments += line + '\n';
                    continue; // comment line
                }
                if (match = line.match(gamma_re)) header.gamma = parseFloat(match[1]);
                if (match = line.match(exposure_re)) header.exposure = parseFloat(match[1]);
                if (match = line.match(format_re)) {
                    header.valid |= RGBE_VALID_FORMAT;
                    header.format = match[1]; //'32-bit_rle_rgbe';
                }
                if (match = line.match(dimensions_re)) {
                    header.valid |= RGBE_VALID_DIMENSIONS;
                    header.height = parseInt(match[1], 10);
                    header.width = parseInt(match[2], 10);
                }
                if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
            }
            if (!(header.valid & RGBE_VALID_FORMAT)) rgbe_error(rgbe_format_error, 'missing format specifier');
            if (!(header.valid & RGBE_VALID_DIMENSIONS)) rgbe_error(rgbe_format_error, 'missing image size specifier');
            return header;
        }, RGBE_ReadPixels_RLE = function(buffer, w, h) {
            const scanline_width = w;
            if (scanline_width < 8 || scanline_width > 0x7fff || // this file is not run length encoded
            2 !== buffer[0] || 2 !== buffer[1] || buffer[2] & 0x80) // return the flat buffer
            return new Uint8Array(buffer);
            if (scanline_width !== (buffer[2] << 8 | buffer[3])) rgbe_error(rgbe_format_error, 'wrong scanline width');
            const data_rgba = new Uint8Array(4 * w * h);
            if (!data_rgba.length) rgbe_error(rgbe_memory_error, 'unable to allocate buffer space');
            let offset = 0, pos = 0;
            const ptr_end = 4 * scanline_width;
            const rgbeStart = new Uint8Array(4);
            const scanline_buffer = new Uint8Array(ptr_end);
            let num_scanlines = h;
            // read in each successive scanline
            while(num_scanlines > 0 && pos < buffer.byteLength){
                if (pos + 4 > buffer.byteLength) rgbe_error(rgbe_read_error);
                rgbeStart[0] = buffer[pos++];
                rgbeStart[1] = buffer[pos++];
                rgbeStart[2] = buffer[pos++];
                rgbeStart[3] = buffer[pos++];
                if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) rgbe_error(rgbe_format_error, 'bad rgbe scanline format');
                // read each of the four channels for the scanline into the buffer
                // first red, then green, then blue, then exponent
                let ptr = 0, count;
                while(ptr < ptr_end && pos < buffer.byteLength){
                    count = buffer[pos++];
                    const isEncodedRun = count > 128;
                    if (isEncodedRun) count -= 128;
                    if (0 === count || ptr + count > ptr_end) rgbe_error(rgbe_format_error, 'bad scanline data');
                    if (isEncodedRun) {
                        // a (encoded) run of the same value
                        const byteValue = buffer[pos++];
                        for(let i = 0; i < count; i++)scanline_buffer[ptr++] = byteValue;
                    //ptr += count;
                    } else {
                        // a literal-run
                        scanline_buffer.set(buffer.subarray(pos, pos + count), ptr);
                        ptr += count;
                        pos += count;
                    }
                }
                // now convert data from buffer into rgba
                // first red, then green, then blue, then exponent (alpha)
                const l = scanline_width; //scanline_buffer.byteLength;
                for(let i = 0; i < l; i++){
                    let off = 0;
                    data_rgba[offset] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 1] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 2] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 3] = scanline_buffer[i + off];
                    offset += 4;
                }
                num_scanlines--;
            }
            return data_rgba;
        };
        const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2.0, e - 128.0) / 255.0;
            destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
            destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
            destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
            destArray[destOffset + 3] = 1;
        };
        const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2.0, e - 128.0) / 255.0;
            // clamping to 65504, the maximum representable value in float16
            destArray[destOffset + 0] = (0, $jw0R5.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
            destArray[destOffset + 1] = (0, $jw0R5.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
            destArray[destOffset + 2] = (0, $jw0R5.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
            destArray[destOffset + 3] = (0, $jw0R5.DataUtils).toHalfFloat(1);
        };
        const byteArray = new Uint8Array(buffer);
        byteArray.pos = 0;
        const rgbe_header_info = RGBE_ReadHeader(byteArray);
        const w = rgbe_header_info.width, h = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h);
        let data, type;
        let numElements;
        switch(this.type){
            case 0, $jw0R5.FloatType:
                numElements = image_rgba_data.length / 4;
                const floatArray = new Float32Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBFloat(image_rgba_data, j * 4, floatArray, j * 4);
                data = floatArray;
                type = (0, $jw0R5.FloatType);
                break;
            case 0, $jw0R5.HalfFloatType:
                numElements = image_rgba_data.length / 4;
                const halfArray = new Uint16Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBHalf(image_rgba_data, j * 4, halfArray, j * 4);
                data = halfArray;
                type = (0, $jw0R5.HalfFloatType);
                break;
            default:
                throw new Error('THREE.RGBELoader: Unsupported type: ' + this.type);
        }
        return {
            width: w,
            height: h,
            data: data,
            header: rgbe_header_info.string,
            gamma: rgbe_header_info.gamma,
            exposure: rgbe_header_info.exposure,
            type: type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            switch(texture.type){
                case 0, $jw0R5.FloatType:
                case 0, $jw0R5.HalfFloatType:
                    texture.colorSpace = (0, $jw0R5.LinearSRGBColorSpace);
                    texture.minFilter = (0, $jw0R5.LinearFilter);
                    texture.magFilter = (0, $jw0R5.LinearFilter);
                    texture.generateMipmaps = false;
                    texture.flipY = true;
                    break;
            }
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}



var $2sw9m = parcelRequire("2sw9m");

var $82VHk = parcelRequire("82VHk");
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2022, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var $cf4be8bf96aa597d$export$1111800106ba519a = function() {
    "use strict";
    // Built with clang version 14.0.4
    // Built from meshoptimizer 0.18
    var wasm_base = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q;iekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq:P8Yqdbk;3sezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhDcbhqinaqae9pmeaDaeaq9RaqaDfae6Egkcsfgocl4cifcd4hxdndndndnaoc9WGgmTmbcbhPcehsawcjdfhzalhHinaraH9Rax6midnaraHaxfgl9RcK6mbczhoinawcj;cbfaogifgoc9WfhOdndndndndnaHaic9WfgAco4fRbbaAci4coG4ciGPlbedibkaO9cb83ibaOcwf9cb83ibxikaOalRblalRbbgAco4gCaCciSgCE86bbaocGfalclfaCfgORbbaAcl4ciGgCaCciSgCE86bbaocVfaOaCfgORbbaAcd4ciGgCaCciSgCE86bbaoc7faOaCfgORbbaAciGgAaAciSgAE86bbaoctfaOaAfgARbbalRbegOco4gCaCciSgCE86bbaoc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc93faAaCfgARbbaOciGgOaOciSgOE86bbaoc94faAaOfgARbbalRbdgOco4gCaCciSgCE86bbaoc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc97faAaCfgARbbaOciGgOaOciSgOE86bbaoc98faAaOfgORbbalRbiglco4gAaAciSgAE86bbaoc99faOaAfgORbbalcl4ciGgAaAciSgAE86bbaoc9:faOaAfgORbbalcd4ciGgAaAciSgAE86bbaocufaOaAfgoRbbalciGglalciSglE86bbaoalfhlxdkaOalRbwalRbbgAcl4gCaCcsSgCE86bbaocGfalcwfaCfgORbbaAcsGgAaAcsSgAE86bbaocVfaOaAfgORbbalRbegAcl4gCaCcsSgCE86bbaoc7faOaCfgORbbaAcsGgAaAcsSgAE86bbaoctfaOaAfgORbbalRbdgAcl4gCaCcsSgCE86bbaoc91faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc4faOaAfgORbbalRbigAcl4gCaCcsSgCE86bbaoc93faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc94faOaAfgORbbalRblgAcl4gCaCcsSgCE86bbaoc95faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc96faOaAfgORbbalRbvgAcl4gCaCcsSgCE86bbaoc97faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc98faOaAfgORbbalRbogAcl4gCaCcsSgCE86bbaoc99faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc9:faOaAfgORbbalRbrglcl4gAaAcsSgAE86bbaocufaOaAfgoRbbalcsGglalcsSglE86bbaoalfhlxekaOal8Pbb83bbaOcwfalcwf8Pbb83bbalczfhlkdnaiam9pmbaiczfhoaral9RcL0mekkaiam6mialTmidnakTmbawaPfRbbhOcbhoazhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkkazcefhzaPcefgPad6hsalhHaPad9hmexvkkcbhlasceGmdxikalaxad2fhCdnakTmbcbhHcehsawcjdfhminaral9Rax6mialTmdalaxfhlawaHfRbbhOcbhoamhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkamcefhmaHcefgHad6hsaHad9hmbkaChlxikcbhocehsinaral9Rax6mdalTmealaxfhlaocefgoad6hsadao9hmbkaChlxdkcbhlasceGTmekc9:hoxikabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqalmbkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;ebf8Kjjjjbaok;yzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;siliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabavcefciGaiVcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:Ohkxekcjjjj94hkkabavcdfciGaiVcetfak87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:Ohqxekcjjjj94hqkabavcufciGaiVcetfaq87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohqxekcjjjj94hqkabavciGaiVcetfaq87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2geTmbinababydbgdcwtcw91:Yadce91cjjj;8ifcjjj98G::NUdbabclfhbaecufgembkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaiczfhiaeczfheadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklz9Kbb";
    var wasm_simd = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q;Aekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq;t9tqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk;h8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhwcbhDinaDae9pmeawaeaD9RaDawfae6Egqcsfgoc9WGgkci2hxakcethmaocl4cifcd4hPabaDad2fhscbhzdnincehHalhOcbhAdninaraO9RaP6miavcj;cbfaAak2fhCaOaPfhlcbhidnakc;ab6mbaral9Rc;Gb6mbcbhoinaCaofhidndndndndnaOaoco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklbalczfhlkdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklzalczfhlkdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklaalczfhlkdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalclfaYpQbfaXc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalcwfaYpQbfaXc:q:yjjbfRbbfhlxekaialpbbbpkl8Walczfhlkaoc;abfhiaocjefak0meaihoaral9Rc;Fb0mbkkdndnaiak9pmbaici4hoinaral9RcK6mdaCaifhXdndndndndnaOaico4fRbbaocoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpklbxikaXalpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaXalpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaXalpbbbpklbalczfhlkaocdfhoaiczfgiak6mbkkalTmbaAci6hHalhOaAcefgohAaoclSmdxekkcbhlaHceGmdkdnakTmbavcjdfazfhiavazfpbdbhYcbhXinaiavcj;cbfaXfgopblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLaoakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEaoamfpblbg3cep9Ta3aQp9op9Hp9rg3aoaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfhiaXczfgXak6mbkkazclfgzad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfhDc9:hoalmexikkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk;uzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:EPliuo97eue978Jjjjjbca9Rhidndnadcl9hmbdnaec98GglTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalae9pmeaiaeciGgvcdtgdVcbczad9R;8kbaiabalcdtfglad;8qbbdnavTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkalaiad;8qbbskdnaec98GgxTmbcbhvabhdinadczfglalpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oawaopmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgvax6mbkkaxae9pmbaiaeciGgvcitgdfcbcaad9R;8kbaiabaxcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oawaopmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalae9pmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbhdabheinaeaepbbbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepkbbaeczfheadclfgdav6mbkkdnaval9pmbaialciGgdcdtgeVcbc;abae9R;8kbaiabavcdtfgvae;8qbbdnadTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepklbkavaiae;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz9Tbb";
    var detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    var wasmpack = new Uint8Array([
        32,
        0,
        65,
        2,
        1,
        106,
        34,
        33,
        3,
        128,
        11,
        4,
        13,
        64,
        6,
        253,
        10,
        7,
        15,
        116,
        127,
        5,
        8,
        12,
        40,
        16,
        19,
        54,
        20,
        9,
        27,
        255,
        113,
        17,
        42,
        67,
        24,
        23,
        146,
        148,
        18,
        14,
        22,
        45,
        70,
        69,
        56,
        114,
        101,
        21,
        25,
        63,
        75,
        136,
        108,
        28,
        118,
        29,
        73,
        115
    ]);
    if (typeof WebAssembly !== 'object') return {
        supported: false
    };
    var wasm = WebAssembly.validate(detector) ? wasm_simd : wasm_base;
    var instance;
    var ready = WebAssembly.instantiate(unpack(wasm), {}).then(function(result) {
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        var result = new Uint8Array(data.length);
        for(var i = 0; i < data.length; ++i){
            var ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
        }
        var write = 0;
        for(var i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        var sbrk = instance.exports.sbrk;
        var count4 = count + 3 & -4;
        var tp = sbrk(count4 * size);
        var sp = sbrk(source.length);
        var heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        var res = fun(tp, count, size, sp, source.length);
        if (res == 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res != 0) throw new Error("Malformed buffer data: " + res);
    }
    var filters = {
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    var decoders = {
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    var workers = [];
    var requestId = 0;
    function createWorker(url) {
        var worker = {
            object: new Worker(url),
            pending: 0,
            requests: {}
        };
        worker.object.onmessage = function(event) {
            var data = event.data;
            worker.pending -= data.count;
            worker.requests[data.id][data.action](data.value);
            delete worker.requests[data.id];
        };
        return worker;
    }
    function initWorkers(count) {
        var source = "var instance; var ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(unpack(wasm)) + "]), {})" + ".then(function(result) { instance = result.instance; instance.exports.__wasm_call_ctors(); });" + "self.onmessage = workerProcess;" + decode.toString() + workerProcess.toString();
        var blob = new Blob([
            source
        ], {
            type: 'text/javascript'
        });
        var url = URL.createObjectURL(blob);
        for(var i = 0; i < count; ++i)workers[i] = createWorker(url);
        URL.revokeObjectURL(url);
    }
    function decodeWorker(count, size, source, mode, filter) {
        var worker = workers[0];
        for(var i = 1; i < workers.length; ++i)if (workers[i].pending < worker.pending) worker = workers[i];
        return new Promise(function(resolve, reject) {
            var data = new Uint8Array(source);
            var id = requestId++;
            worker.pending += count;
            worker.requests[id] = {
                resolve: resolve,
                reject: reject
            };
            worker.object.postMessage({
                id: id,
                count: count,
                size: size,
                source: data,
                mode: mode,
                filter: filter
            }, [
                data.buffer
            ]);
        });
    }
    function workerProcess(event) {
        ready.then(function() {
            var data = event.data;
            try {
                var target = new Uint8Array(data.count * data.size);
                decode(instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
                self.postMessage({
                    id: data.id,
                    count: data.count,
                    action: "resolve",
                    value: target
                }, [
                    target.buffer
                ]);
            } catch (error) {
                self.postMessage({
                    id: data.id,
                    count: data.count,
                    action: "reject",
                    value: error
                });
            }
        });
    }
    return {
        ready: ready,
        supported: true,
        useWorkers: function(count) {
            initWorkers(count);
        },
        decodeVertexBuffer: function(target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer: function(target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeGltfBufferAsync: function(count, size, source, mode, filter) {
            if (workers.length > 0) return decodeWorker(count, size, source, decoders[mode], filters[filter]);
            return ready.then(function() {
                var target = new Uint8Array(count * size);
                decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
                return target;
            });
        }
    };
}();



var $ctZJO = parcelRequire("ctZJO");
const $f80a30882458d01d$export$aa2e643b4f1d84bd = 4;
const $f80a30882458d01d$export$bd0d6802977cd523 = Object.freeze({
    version: 1,
    textureWidth: 512,
    triangle: Object.freeze({
        texels: 8,
        stride: 8 * $f80a30882458d01d$export$aa2e643b4f1d84bd
    }),
    bvhNode: Object.freeze({
        texels: 4,
        stride: 4 * $f80a30882458d01d$export$aa2e643b4f1d84bd,
        leafSize: 8
    }),
    material: Object.freeze({
        texels: 5,
        stride: 5 * $f80a30882458d01d$export$aa2e643b4f1d84bd
    }),
    limits: Object.freeze({
        maxBounces: 8,
        maxTransparentSteps: 8
    })
});


class $4357635f2b0a2231$export$5c4ccc108b94ed61 {
    constructor(encodedScene){
        const { triangle: triangle, bvh: bvh, material: material } = encodedScene || {};
        if (!triangle?.dataTexture || !bvh?.dataTexture || !material?.dataTexture) throw new Error('[PathTracing] CompiledScene requires triangle, BVH, and material buffers.');
        this.layoutVersion = (0, $f80a30882458d01d$export$bd0d6802977cd523).version;
        this.triangle = triangle;
        this.bvh = bvh;
        this.material = material;
        this.disposed = false;
    }
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.triangle.dataTexture.dispose();
        this.bvh.dataTexture.dispose();
        this.material.dataTexture.dispose();
    }
}



var $jw0R5 = parcelRequire("jw0R5");

var $fMyA4 = parcelRequire("fMyA4");

const $4f9e5cf7c14c121e$export$f8d507d96c342ed1 = (0, $f80a30882458d01d$export$bd0d6802977cd523).triangle.texels;
const $4f9e5cf7c14c121e$export$d393949a0b2bdcc6 = (0, $f80a30882458d01d$export$bd0d6802977cd523).bvhNode.texels;
const $4f9e5cf7c14c121e$export$f975357ddbdd6976 = (0, $f80a30882458d01d$export$bd0d6802977cd523).material.texels;
const $4f9e5cf7c14c121e$export$caef2c0e9624096c = (0, $f80a30882458d01d$export$bd0d6802977cd523).textureWidth;
const $4f9e5cf7c14c121e$export$f4cd990fbac81a8e = (0, $f80a30882458d01d$export$bd0d6802977cd523).bvhNode.leafSize;
const $4f9e5cf7c14c121e$export$5d4ce8383a4d99bb = (0, $f80a30882458d01d$export$bd0d6802977cd523).limits.maxBounces;
const $4f9e5cf7c14c121e$export$b16373dbc4a645a0 = (0, $f80a30882458d01d$export$bd0d6802977cd523).limits.maxTransparentSteps;



const $94e9fb3ad420642a$var$geometryAttributeAccessors = [
    'getX',
    'getY',
    'getZ',
    'getW'
];
function $94e9fb3ad420642a$var$copyFloatAttribute(attribute, itemSize, count) {
    const values = new Float32Array(count * itemSize);
    if (attribute && attribute.count === count) {
        for(let vertexIndex = 0; vertexIndex < count; vertexIndex++)for(let componentIndex = 0; componentIndex < itemSize; componentIndex++)values[vertexIndex * itemSize + componentIndex] = attribute[$94e9fb3ad420642a$var$geometryAttributeAccessors[componentIndex]](vertexIndex);
    }
    return new (0, $jw0R5.Float32BufferAttribute)(values, itemSize);
}
function $94e9fb3ad420642a$var$normalizeGeometryForEncoding(geometry) {
    const position = geometry.getAttribute('position');
    if (!position || position.itemSize < 3) throw new Error('[PathTracing] Mesh geometry requires a vec3 position attribute.');
    if (!geometry.getAttribute('normal')) geometry.computeVertexNormals();
    const vertexCount = position.count;
    geometry.setAttribute('position', $94e9fb3ad420642a$var$copyFloatAttribute(geometry.getAttribute('position'), 3, vertexCount));
    geometry.setAttribute('normal', $94e9fb3ad420642a$var$copyFloatAttribute(geometry.getAttribute('normal'), 3, vertexCount));
    geometry.setAttribute('uv', $94e9fb3ad420642a$var$copyFloatAttribute(geometry.getAttribute('uv'), 2, vertexCount));
    Object.keys(geometry.attributes).forEach((attributeName)=>{
        if (![
            'position',
            'normal',
            'uv'
        ].includes(attributeName)) geometry.deleteAttribute(attributeName);
    });
    geometry.morphAttributes = {};
    return geometry;
}
class $94e9fb3ad420642a$var$Triangle {
    constructor(v1, v2, v3, n1, n2, n3, uv1, uv2, uv3, materialIndex = 0){
        // positions normals and uvs
        this.p1 = v1;
        this.p2 = v2;
        this.p3 = v3;
        this.n1 = n1;
        this.n2 = n2;
        this.n3 = n3;
        this.uv1 = uv1;
        this.uv2 = uv2;
        this.uv3 = uv3;
        this.materialIndex = materialIndex;
        this.aa = new (0, $jw0R5.Vector3)(Infinity, Infinity, Infinity);
        this.bb = new (0, $jw0R5.Vector3)(-Infinity, -Infinity, -Infinity);
        this.center = new (0, $jw0R5.Vector3)(0, 0, 0);
        this.computeBoundingBox();
        this.computeCenteic();
    }
    computeBoundingBox() {
        this.aa.x = Math.min(this.p1.x, Math.min(this.p2.x, this.p3.x));
        this.aa.y = Math.min(this.p1.y, Math.min(this.p2.y, this.p3.y));
        this.aa.z = Math.min(this.p1.z, Math.min(this.p2.z, this.p3.z));
        this.bb.x = Math.max(this.p1.x, Math.max(this.p2.x, this.p3.x));
        this.bb.y = Math.max(this.p1.y, Math.max(this.p2.y, this.p3.y));
        this.bb.z = Math.max(this.p1.z, Math.max(this.p2.z, this.p3.z));
    }
    computeCenteic() {
        this.center = new (0, $jw0R5.Vector3)((this.p1.x + this.p2.x + this.p3.x) / 3, (this.p1.y + this.p2.y + this.p3.y) / 3, (this.p1.z + this.p2.z + this.p3.z) / 3);
    }
}
class $94e9fb3ad420642a$var$BVHNode {
    constructor(){
        this.aa = new (0, $jw0R5.Vector3)(Infinity, Infinity, Infinity);
        this.bb = new (0, $jw0R5.Vector3)(-Infinity, -Infinity, -Infinity);
        this.id = null;
        this.isLeaf = null;
        this.left = null;
        this.right = null;
        this.index = null;
        this.size = null;
    }
}
class $94e9fb3ad420642a$var$BVHBuilder {
    constructor(geometry, materialIndices = [], leafSize = (0, $4f9e5cf7c14c121e$export$f4cd990fbac81a8e)){
        this.position = geometry.attributes.position.array;
        if (!geometry.attributes.normal) geometry.computeVertexNormals();
        this.normal = geometry.attributes.normal.array;
        if (geometry.attributes.uv) this.uv = geometry.attributes.uv.array;
        else this.uv = [];
        this.totalTriangles = this.position.length / 9;
        this.materialIndices = materialIndices;
        this.triangles = [];
        this.nodes = [];
        this.leafSize = leafSize;
        this.prepare();
    }
    prepare() {
        this.nodes = [];
        this.triangles = [];
        for(let i = 0; i < this.totalTriangles; ++i)this.triangles.push(new $94e9fb3ad420642a$var$Triangle(new (0, $jw0R5.Vector3)(this.position[9 * i], this.position[9 * i + 1], this.position[9 * i + 2]), new (0, $jw0R5.Vector3)(this.position[9 * i + 3], this.position[9 * i + 4], this.position[9 * i + 5]), new (0, $jw0R5.Vector3)(this.position[9 * i + 6], this.position[9 * i + 7], this.position[9 * i + 8]), new (0, $jw0R5.Vector3)(this.normal[9 * i], this.normal[9 * i + 1], this.normal[9 * i + 2]), new (0, $jw0R5.Vector3)(this.normal[9 * i + 3], this.normal[9 * i + 4], this.normal[9 * i + 5]), new (0, $jw0R5.Vector3)(this.normal[9 * i + 6], this.normal[9 * i + 7], this.normal[9 * i + 8]), new (0, $jw0R5.Vector2)(this.uv[6 * i], this.uv[6 * i + 1]), new (0, $jw0R5.Vector2)(this.uv[6 * i + 2], this.uv[6 * i + 3]), new (0, $jw0R5.Vector2)(this.uv[6 * i + 4], this.uv[6 * i + 5]), this.materialIndices[i] ?? 0));
    }
    setGeometry(geometry) {
        this.position = geometry.attributes.position.array;
        if (!geometry.attributes.normal) geometry.computeVertexNormals();
        this.normal = geometry.attributes.normal.array;
        if (geometry.attributes.uv) {
            this.uv = geometry.attributes.uv.array;
            this.hasUv = true;
        } else {
            this.uv = [];
            this.hasUv = false;
        }
        this.init();
    }
    rangeSort(arr, left, right, compareFn) {
        let leftArr = arr.slice(0, left);
        let rangeArr = arr.slice(left, right);
        let rightArr = arr.slice(right, this.totalTriangles);
        rangeArr.sort(compareFn);
        return leftArr.concat(rangeArr).concat(rightArr);
    }
    sortTrianglesByLongestAxis(node, left, right) {
        let lenX = node.bb.x - node.aa.x;
        let lenY = node.bb.y - node.aa.y;
        let lenZ = node.bb.z - node.aa.z;
        if (lenX >= lenY && lenX >= lenZ) this.triangles = this.rangeSort(this.triangles, left, right + 1, (a, b)=>{
            return a.center.x - b.center.x;
        });
        if (lenY >= lenX && lenY >= lenZ) this.triangles = this.rangeSort(this.triangles, left, right + 1, (a, b)=>{
            return a.center.y - b.center.y;
        });
        if (lenZ >= lenY && lenZ >= lenX) this.triangles = this.rangeSort(this.triangles, left, right + 1, (a, b)=>{
            return a.center.z - b.center.z;
        });
    }
    createNode(left, right) {
        let node = new $94e9fb3ad420642a$var$BVHNode();
        let triangles = this.triangles;
        for(let i = left; i <= right; ++i){
            let minX = Math.min(triangles[i].p1.x, Math.min(triangles[i].p2.x, triangles[i].p3.x));
            let minY = Math.min(triangles[i].p1.y, Math.min(triangles[i].p2.y, triangles[i].p3.y));
            let minZ = Math.min(triangles[i].p1.z, Math.min(triangles[i].p2.z, triangles[i].p3.z));
            node.aa.x = Math.min(node.aa.x, minX);
            node.aa.y = Math.min(node.aa.y, minY);
            node.aa.z = Math.min(node.aa.z, minZ);
            let maxX = Math.max(triangles[i].p1.x, Math.max(triangles[i].p2.x, triangles[i].p3.x));
            let maxY = Math.max(triangles[i].p1.y, Math.max(triangles[i].p2.y, triangles[i].p3.y));
            let maxZ = Math.max(triangles[i].p1.z, Math.max(triangles[i].p2.z, triangles[i].p3.z));
            node.bb.x = Math.max(node.bb.x, maxX);
            node.bb.y = Math.max(node.bb.y, maxY);
            node.bb.z = Math.max(node.bb.z, maxZ);
        }
        this.nodes.push(node);
        node.id = this.nodes.length - 1;
        node.isLeaf = false;
        node.left = node.right = node.index = 0;
        return node;
    }
    createSahNode(left, right) {
        let Node = this.createNode(left, right);
        let Split = this.calculateSah(left, right);
        return {
            Split: Split,
            Node: Node
        };
    }
    calculateSah(left, right) {
        let Cost = Infinity;
        let Split = 0;
        let Axis = 0;
        // let Split = Math.floor((left + right) / 2);
        for(let axis = 0; axis < 3; ++axis){
            this.sortTrianglesByAxis(axis, left, right);
            let leftMin = [];
            let leftMax = [];
            let rightMin = [];
            let rightMax = [];
            // initialize left and right aabb box pairs
            for(let i = 0; i < right - left + 1; ++i){
                leftMin.push(new (0, $jw0R5.Vector3)(Infinity, Infinity, Infinity));
                rightMin.push(new (0, $jw0R5.Vector3)(Infinity, Infinity, Infinity));
                leftMax.push(new (0, $jw0R5.Vector3)(-Infinity, -Infinity, -Infinity));
                rightMax.push(new (0, $jw0R5.Vector3)(-Infinity, -Infinity, -Infinity));
            }
            // calculate the all possible pair of leftAABB and rightAABB
            for(let i = left; i <= right; ++i){
                let t = this.triangles[i];
                let bias = i === left ? 0 : 1;
                leftMax[i - left].x = Math.max(leftMax[i - left - bias].x, Math.max(t.p1.x, Math.max(t.p2.x, t.p3.x)));
                leftMax[i - left].y = Math.max(leftMax[i - left - bias].y, Math.max(t.p1.y, Math.max(t.p2.y, t.p3.y)));
                leftMax[i - left].z = Math.max(leftMax[i - left - bias].z, Math.max(t.p1.z, Math.max(t.p2.z, t.p3.z)));
                leftMin[i - left].x = Math.min(leftMin[i - left - bias].x, Math.min(t.p1.x, Math.min(t.p2.x, t.p3.x)));
                leftMin[i - left].y = Math.min(leftMin[i - left - bias].y, Math.min(t.p1.y, Math.min(t.p2.y, t.p3.y)));
                leftMin[i - left].z = Math.min(leftMin[i - left - bias].z, Math.min(t.p1.z, Math.min(t.p2.z, t.p3.z)));
                t = this.triangles[left + right - i];
                rightMax[right - i].x = Math.max(rightMax[right - i + bias].x, Math.max(t.p1.x, Math.max(t.p2.x, t.p3.x)));
                rightMax[right - i].y = Math.max(rightMax[right - i + bias].y, Math.max(t.p1.y, Math.max(t.p2.y, t.p3.y)));
                rightMax[right - i].z = Math.max(rightMax[right - i + bias].z, Math.max(t.p1.z, Math.max(t.p2.z, t.p3.z)));
                rightMin[right - i].x = Math.min(rightMin[right - i + bias].x, Math.min(t.p1.x, Math.min(t.p2.x, t.p3.x)));
                rightMin[right - i].y = Math.min(rightMin[right - i + bias].y, Math.min(t.p1.y, Math.min(t.p2.y, t.p3.y)));
                rightMin[right - i].z = Math.min(rightMin[right - i + bias].z, Math.min(t.p1.z, Math.min(t.p2.z, t.p3.z)));
            }
            // calculate the cost by pre computed pair of left and right part
            let cost = Infinity;
            let split = left;
            for(let i = left; i <= right - 1; ++i){
                let leftAA = leftMin[i - left];
                let leftBB = leftMax[i - left];
                let lenX = leftBB.x - leftAA.x;
                let lenY = leftBB.y - leftAA.y;
                let lenZ = leftBB.z - leftAA.z;
                let leftS = lenX * lenY + lenX * lenZ + lenY * lenZ;
                let rightAA = rightMin[i - left];
                let rightBB = rightMax[i - left];
                lenX = rightBB.x - rightAA.x;
                lenY = rightBB.y - rightAA.y;
                lenZ = rightBB.z - rightAA.z;
                let rightS = lenX * lenY + lenX * lenZ + lenY * lenZ;
                let S = leftS * (i - left + 1) + rightS * (right - i);
                if (S < cost) {
                    cost = S;
                    split = i;
                }
            }
            if (cost < Cost) {
                Cost = cost;
                Axis = axis;
                Split = split;
            }
        }
        this.sortTrianglesByAxis(Axis, left, right);
        return Split;
    }
    buildRecursiveMedian(left, right) {
        if (left > right) return;
        let node = this.createNode(left, right);
        if (right - left + 1 <= this.leafSize) {
            node.isLeaf = true;
            node.index = left;
            node.size = right - left + 1;
            return node.id;
        }
        this.sortTrianglesByLongestAxis(node, left, right);
        let mid = Math.floor((left + right) / 2);
        let l = this.buildRecursiveMedian(left, mid);
        let r = this.buildRecursiveMedian(mid + 1, right);
        node.left = l;
        node.right = r;
        return node.id;
    }
    buildRecursiveSAH(left, right) {
        if (left > right) return;
        let node = this.createNode(left, right);
        node.isLeaf = false;
        if (right - left + 1 <= this.leafSize) {
            node.isLeaf = true;
            node.index = left;
            node.size = right - left + 1;
            return node.id;
        }
        let Split = this.calculateSah(left, right);
        node.left = this.buildRecursiveSAH(left, Split);
        node.right = this.buildRecursiveSAH(Split + 1, right);
        // console.log(left, Split, right);
        return node.id;
    }
    buildIterativeMedian() {
        let $stacks = [];
        function push(l, r, lastNode, flag) {
            $stacks.push([
                l,
                r,
                lastNode,
                flag
            ]);
        }
        function pop() {
            return $stacks.pop();
        }
        push(0, this.totalTriangles - 1, null, null);
        while($stacks.length > 0){
            let stack = pop();
            let left = stack[0];
            let right = stack[1];
            let lastNode = stack[2];
            let flag = stack[3];
            if (left > right) return;
            let node = this.createNode(left, right);
            if (lastNode) {
                if (flag === "left") lastNode.left = node.id;
                else if (flag === "right") lastNode.right = node.id;
            }
            if (right - left < this.leafSize) {
                node.isLeaf = true;
                node.index = left;
                node.size = right - left + 1;
                continue;
            }
            this.sortTrianglesByLongestAxis(node, left, right);
            let mid = Math.floor((left + right) / 2);
            if (mid < left || mid > right) continue;
            push(left, mid, node, "left");
            push(mid + 1, right, node, "right");
        }
    }
    buildIterativeSAH() {
        let $stacks = [];
        function $call(l, r, split, node) {
            $stacks.push({
                ok: false,
                left: l,
                right: r,
                split: split,
                node: node
            });
        }
        let { Split: Split, Node: Node } = this.createSahNode(0, this.totalTriangles - 1);
        $call(0, this.totalTriangles - 1, Split, Node);
        while($stacks.length > 0)$stacks.forEach((stack, index)=>{
            if (stack.ok) {
                $stacks.splice(index, 1);
                return;
            }
            let { left: left, right: right, node: node } = stack;
            if (left > right) {
                stack.ok = true;
                $stacks.splice(index, 1);
                return;
            }
            node.isLeaf = false;
            if (right - left + 1 <= this.leafSize) {
                node.index = left;
                node.size = right - left + 1;
                node.isLeaf = true;
                stack.ok = true;
                $stacks.splice(index, 1);
                return;
            }
            let split = stack.split;
            let obj = this.createSahNode(left, split);
            node.left = obj.Node.id;
            $call(left, split, obj.Split, obj.Node);
            obj = this.createSahNode(split + 1, right);
            node.right = obj.Node.id;
            $call(split + 1, right, obj.Split, obj.Node);
            stack.node = node;
            stack.ok = true;
            $stacks.splice(index, 1);
        });
    }
    build(type = 0, method = 0) {
        if (type === 0) {
            if (method === 1) {
                this.buildRecursiveSAH(0, this.totalTriangles - 1);
                return;
            }
            this.buildRecursiveMedian(0, this.totalTriangles - 1);
            return;
        }
        if (method === 1) {
            this.buildIterativeSAH();
            return;
        }
        this.buildIterativeMedian();
    }
}
class $94e9fb3ad420642a$export$b08461fed54ebde9 {
    constructor(model, options = {}){
        this.model = model;
        this.meshFilter = options.meshFilter || null;
        this.geometries = [];
        this.geometryMaterialIndices = [];
        this.materials = [];
        this.materialIndexMap = new Map();
        this.textureSlotMaps = {
            albedo: new Map(),
            normal: new Map(),
            metallicRoughness: new Map(),
            emissive: new Map()
        };
        this.textureSlots = {
            albedo: [],
            normal: [],
            metallicRoughness: [],
            emissive: []
        };
    }
    registerTexture(type, texture) {
        if (!texture) return -1;
        const textureSlotMap = this.textureSlotMaps[type];
        const textureSlots = this.textureSlots[type];
        const key = texture.uuid;
        if (textureSlotMap.has(key)) return textureSlotMap.get(key);
        const slotIndex = textureSlots.length;
        textureSlotMap.set(key, slotIndex);
        textureSlots.push(texture);
        return slotIndex;
    }
    registerMaterial(material) {
        const key = material?.uuid || '__default_material__';
        if (!this.materialIndexMap.has(key)) {
            this.materialIndexMap.set(key, this.materials.length);
            this.materials.push(material || null);
        }
        return this.materialIndexMap.get(key);
    }
    generate() {
        this.model.updateWorldMatrix(true, true);
        this.model.traverse((child)=>{
            if (child.isMesh && (!this.meshFilter || this.meshFilter(child))) {
                const geometry = child.geometry.clone().toNonIndexed();
                geometry.applyMatrix4(child.matrixWorld);
                $94e9fb3ad420642a$var$normalizeGeometryForEncoding(geometry);
                const triangleCount = geometry.attributes.position.array.length / 9;
                const materialIndices = new Array(triangleCount).fill(0);
                const materials = Array.isArray(child.material) ? child.material : [
                    child.material
                ];
                if (materials.length > 1 && geometry.groups.length > 0) geometry.groups.forEach((group)=>{
                    const triangleStart = Math.floor(group.start / 3);
                    const triangleCountInGroup = Math.floor(group.count / 3);
                    const materialIndex = this.registerMaterial(materials[group.materialIndex] || materials[0] || null);
                    for(let i = 0; i < triangleCountInGroup; i++)materialIndices[triangleStart + i] = materialIndex;
                });
                else {
                    const materialIndex = this.registerMaterial(materials[0] || null);
                    materialIndices.fill(materialIndex);
                }
                this.geometries.push(geometry);
                this.geometryMaterialIndices.push(materialIndices);
            }
        });
        if (this.geometries.length === 0) throw new Error('[PathTracing] No meshes matched the SceneGenerator filter.');
        const mergedMaterialIndices = this.geometryMaterialIndices.flat();
        let mergedGeometry = null;
        let builder;
        try {
            mergedGeometry = (0, $fMyA4.mergeGeometries)(this.geometries, false);
            if (!mergedGeometry) throw new Error('[PathTracing] Failed to merge normalized scene geometry.');
            builder = new $94e9fb3ad420642a$var$BVHBuilder(mergedGeometry, mergedMaterialIndices);
        } finally{
            this.geometries.forEach((geometry)=>geometry.dispose());
            this.geometries.length = 0;
            mergedGeometry?.dispose();
        }
        builder.build();
        const { totalTriangles: totalTriangles, triangles: triangles, nodes: nodes } = builder;
        const texelWidth = (0, $4f9e5cf7c14c121e$export$caef2c0e9624096c);
        let totalTexels = (0, $4f9e5cf7c14c121e$export$f8d507d96c342ed1) * totalTriangles;
        let texelHeight = Math.max(1, Math.ceil(totalTexels / texelWidth));
        const th = texelHeight;
        let triangleArray = new Float32Array(texelWidth * texelHeight * 4);
        let stride = (0, $f80a30882458d01d$export$bd0d6802977cd523).triangle.stride;
        // Triangles Data Texture
        for(let i = 0; i < totalTriangles; ++i){
            let triangle = triangles[i];
            let vp1 = triangle.p1;
            let vp2 = triangle.p2;
            let vp3 = triangle.p3;
            let vn1 = triangle.n1;
            let vn2 = triangle.n2;
            let vn3 = triangle.n3;
            let vt1 = triangle.uv1;
            let vt2 = triangle.uv2;
            let vt3 = triangle.uv3;
            //slot 0
            triangleArray[stride * i + 0] = vp1.x;
            triangleArray[stride * i + 1] = vp1.y;
            triangleArray[stride * i + 2] = vp1.z;
            triangleArray[stride * i + 3] = vp2.x;
            //slot 1
            triangleArray[stride * i + 4] = vp2.y;
            triangleArray[stride * i + 5] = vp2.z;
            triangleArray[stride * i + 6] = vp3.x;
            triangleArray[stride * i + 7] = vp3.y;
            //slot 2
            triangleArray[stride * i + 8] = vp3.z;
            triangleArray[stride * i + 9] = vn1.x;
            triangleArray[stride * i + 10] = vn1.y;
            triangleArray[stride * i + 11] = vn1.z;
            //slot 3
            triangleArray[stride * i + 12] = vn2.x;
            triangleArray[stride * i + 13] = vn2.y;
            triangleArray[stride * i + 14] = vn2.z;
            triangleArray[stride * i + 15] = vn3.x;
            //slot 4
            triangleArray[stride * i + 16] = vn3.y;
            triangleArray[stride * i + 17] = vn3.z;
            triangleArray[stride * i + 18] = vt1.x;
            triangleArray[stride * i + 19] = vt1.y;
            //slot 5
            triangleArray[stride * i + 20] = vt2.x;
            triangleArray[stride * i + 21] = vt2.y;
            triangleArray[stride * i + 22] = vt3.x;
            triangleArray[stride * i + 23] = vt3.y;
            //slot 6
            triangleArray[stride * i + 24] = triangle.materialIndex;
            triangleArray[stride * i + 25] = 0;
            triangleArray[stride * i + 26] = 0;
            triangleArray[stride * i + 27] = 0;
            //slot 7
            triangleArray[stride * i + 28] = 0;
            triangleArray[stride * i + 29] = 0;
            triangleArray[stride * i + 30] = 0;
            triangleArray[stride * i + 31] = 0;
        }
        const triangleDataTexture = new (0, $jw0R5.DataTexture)(triangleArray, texelWidth, texelHeight, (0, $jw0R5.RGBAFormat), (0, $jw0R5.FloatType), (0, $jw0R5.Texture).DEFAULT_MAPPING, (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.NearestFilter), (0, $jw0R5.NearestFilter), 1);
        triangleDataTexture.colorSpace = (0, $jw0R5.NoColorSpace);
        triangleDataTexture.flipY = false;
        triangleDataTexture.generateMipmaps = false;
        triangleDataTexture.needsUpdate = true;
        triangleDataTexture.unpackAlignment = 8;
        totalTexels = (0, $4f9e5cf7c14c121e$export$f975357ddbdd6976) * this.materials.length;
        texelHeight = Math.max(1, Math.ceil(totalTexels / texelWidth));
        const mh = texelHeight;
        const materialArray = new Float32Array(texelWidth * texelHeight * 4);
        stride = (0, $f80a30882458d01d$export$bd0d6802977cd523).material.stride;
        for(let i = 0; i < this.materials.length; ++i){
            const material = this.materials[i];
            const color = material?.color || new (0, $jw0R5.Color)(1, 1, 1);
            const emissive = material?.emissive || new (0, $jw0R5.Color)(0, 0, 0);
            const emissiveIntensity = material?.emissiveIntensity ?? 1.0;
            const alphaMode = material?.transparent ? 2.0 : (material?.alphaTest ?? 0.0) > 0.0 ? 1.0 : 0.0;
            if (material?.roughnessMap && material?.metalnessMap && material.roughnessMap.uuid !== material.metalnessMap.uuid) console.warn('[PathTracing] roughnessMap and metalnessMap differ; using metalnessMap as metallic-roughness texture.', material);
            const metallicRoughnessTexture = material?.metalnessMap || material?.roughnessMap || null;
            materialArray[stride * i + 0] = color.r;
            materialArray[stride * i + 1] = color.g;
            materialArray[stride * i + 2] = color.b;
            materialArray[stride * i + 3] = material?.roughness ?? 1.0;
            materialArray[stride * i + 4] = material?.metalness ?? 0.0;
            materialArray[stride * i + 5] = emissive.r * emissiveIntensity;
            materialArray[stride * i + 6] = emissive.g * emissiveIntensity;
            materialArray[stride * i + 7] = emissive.b * emissiveIntensity;
            materialArray[stride * i + 8] = this.registerTexture('albedo', material?.map || null);
            materialArray[stride * i + 9] = this.registerTexture('normal', material?.normalMap || null);
            materialArray[stride * i + 10] = this.registerTexture('metallicRoughness', metallicRoughnessTexture);
            materialArray[stride * i + 11] = this.registerTexture('emissive', material?.emissiveMap || null);
            materialArray[stride * i + 12] = material?.opacity ?? 1.0;
            materialArray[stride * i + 13] = material?.normalScale?.x ?? 1.0;
            materialArray[stride * i + 14] = material?.normalScale?.y ?? 1.0;
            materialArray[stride * i + 15] = alphaMode;
            materialArray[stride * i + 16] = material?.side === (0, $jw0R5.DoubleSide) ? 1.0 : 0.0;
            materialArray[stride * i + 17] = 0.0;
            materialArray[stride * i + 18] = 0.0;
            materialArray[stride * i + 19] = 0.0;
        }
        const materialDataTexture = new (0, $jw0R5.DataTexture)(materialArray, texelWidth, texelHeight, (0, $jw0R5.RGBAFormat), (0, $jw0R5.FloatType), (0, $jw0R5.Texture).DEFAULT_MAPPING, (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.NearestFilter), (0, $jw0R5.NearestFilter), 1);
        materialDataTexture.colorSpace = (0, $jw0R5.NoColorSpace);
        materialDataTexture.flipY = false;
        materialDataTexture.generateMipmaps = false;
        materialDataTexture.needsUpdate = true;
        materialDataTexture.unpackAlignment = 8;
        // BVH Datatexture
        const totalNodes = nodes.length;
        totalTexels = (0, $4f9e5cf7c14c121e$export$d393949a0b2bdcc6) * totalNodes;
        texelHeight = Math.max(1, Math.ceil(totalTexels / texelWidth));
        const bh = texelHeight;
        stride = (0, $f80a30882458d01d$export$bd0d6802977cd523).bvhNode.stride;
        const nodesArray = new Float32Array(texelWidth * texelHeight * 4);
        for(let i = 0; i < totalNodes; ++i){
            let node = nodes[i];
            // slot 0
            nodesArray[i * stride] = node.aa.x;
            nodesArray[i * stride + 1] = node.aa.y;
            nodesArray[i * stride + 2] = node.aa.z;
            nodesArray[i * stride + 3] = node.bb.x;
            // slot 1
            nodesArray[i * stride + 4] = node.bb.y;
            nodesArray[i * stride + 5] = node.bb.z;
            nodesArray[i * stride + 6] = node.id;
            nodesArray[i * stride + 7] = nodes[i].isLeaf ? 1 : 0;
            // slot 2
            nodesArray[i * stride + 8] = node.left;
            nodesArray[i * stride + 9] = node.right;
            nodesArray[i * stride + 10] = node.index;
            nodesArray[i * stride + 11] = node.size;
            // slot 3
            nodesArray[i * stride + 12] = 0;
            nodesArray[i * stride + 13] = 0;
            nodesArray[i * stride + 14] = 0;
            nodesArray[i * stride + 15] = 0;
        }
        // write nodes data into texture
        const bvhDataTexture = new (0, $jw0R5.DataTexture)(nodesArray, texelWidth, texelHeight, (0, $jw0R5.RGBAFormat), (0, $jw0R5.FloatType), (0, $jw0R5.Texture).DEFAULT_MAPPING, (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.ClampToEdgeWrapping), (0, $jw0R5.NearestFilter), (0, $jw0R5.NearestFilter), 1);
        bvhDataTexture.colorSpace = (0, $jw0R5.NoColorSpace);
        bvhDataTexture.flipY = false;
        bvhDataTexture.generateMipmaps = false;
        bvhDataTexture.needsUpdate = true;
        bvhDataTexture.unpackAlignment = 4;
        return {
            triangle: {
                dataTexture: triangleDataTexture,
                textureWidth: (0, $4f9e5cf7c14c121e$export$caef2c0e9624096c),
                textureHeight: th
            },
            bvh: {
                dataTexture: bvhDataTexture,
                textureWidth: (0, $4f9e5cf7c14c121e$export$caef2c0e9624096c),
                textureHeight: bh
            },
            material: {
                dataTexture: materialDataTexture,
                textureWidth: (0, $4f9e5cf7c14c121e$export$caef2c0e9624096c),
                textureHeight: mh,
                count: this.materials.length,
                textures: this.textureSlots
            }
        };
    }
}


/**
 * Transitional WebGL scene encoder.
 *
 * SceneGenerator still owns the legacy collection, BVH, and packing implementation.
 * Keeping it behind this boundary lets those stages be extracted independently
 * without changing PathTracer or application code again.
 */ class $a8f87efd2a86b1c3$export$ead60f24bf9e1b18 {
    encode(scene, options = {}) {
        return new (0, $94e9fb3ad420642a$export$b08461fed54ebde9)(scene, options).generate();
    }
}


class $0bec07c4e8263f03$export$af30c3d44590de39 {
    constructor({ encoder: encoder = new (0, $a8f87efd2a86b1c3$export$ead60f24bf9e1b18)(), encoderOptions: encoderOptions = {} } = {}){
        this.encoder = encoder;
        this.encoderOptions = encoderOptions;
    }
    compile(scene, options = {}) {
        if (!scene?.traverse) throw new TypeError('[PathTracing] SceneCompiler.compile requires a Three.js Object3D.');
        const encodedScene = this.encoder.encode(scene, {
            ...this.encoderOptions,
            ...options
        });
        return new (0, $4357635f2b0a2231$export$5c4ccc108b94ed61)(encodedScene);
    }
}



var $jw0R5 = parcelRequire("jw0R5");

var $jw0R5 = parcelRequire("jw0R5");
class $d0e64fd1c8ab14ed$export$802bc10488da99c7 {
    constructor(){
        this.isPass = true;
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
    dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $d0e64fd1c8ab14ed$var$_camera = new (0, $jw0R5.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $d0e64fd1c8ab14ed$var$FullscreenTriangleGeometry extends (0, $jw0R5.BufferGeometry) {
    constructor(){
        super();
        this.setAttribute('position', new (0, $jw0R5.Float32BufferAttribute)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $jw0R5.Float32BufferAttribute)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $d0e64fd1c8ab14ed$var$_geometry = new $d0e64fd1c8ab14ed$var$FullscreenTriangleGeometry();
class $d0e64fd1c8ab14ed$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $jw0R5.Mesh)($d0e64fd1c8ab14ed$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $d0e64fd1c8ab14ed$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}



var $jw0R5 = parcelRequire("jw0R5");
class $0bbda9d3fe0392ad$export$f1ac3a587b6cbb5d extends (0, $jw0R5.ShaderMaterial) {
    set needsUpdate(v) {
        super.needsUpdate = true;
        this.dispatchEvent({
            type: 'recompilation'
        });
    }
    constructor(shader){
        super(shader);
        for(const key in this.uniforms)Object.defineProperty(this, key, {
            get () {
                return this.uniforms[key].value;
            },
            set (v) {
                this.uniforms[key].value = v;
            }
        });
    }
}


class $9740c2581f87cab8$export$59f4d53140b73aac extends (0, $0bbda9d3fe0392ad$export$f1ac3a587b6cbb5d) {
    constructor(){
        super({
            transparent: false,
            depthWrite: false,
            depthTest: false,
            uniforms: {
                renderTexture: {
                    type: "t",
                    value: null
                },
                toneMappingMode: {
                    type: "i",
                    value: 2
                },
                exposure: {
                    type: "f",
                    value: 1.0
                }
            },
            vertexShader: /* glsl */ `
                void main() {
                    gl_Position = vec4(position, 1.0);
                }
            `,
            fragmentShader: /* glsl */ `
                uniform sampler2D renderTexture;
                uniform int toneMappingMode;
                uniform float exposure;

                vec3 reinhardToneMapping(vec3 color) {
                    return color / (1.0 + color);
                }

                vec3 acesToneMapping(vec3 color) {
                    const float a = 2.51;
                    const float b = 0.03;
                    const float c = 2.43;
                    const float d = 0.59;
                    const float e = 0.14;
                    return clamp((color * (a * color + b)) / (color * (c * color + d) + e), 0.0, 1.0);
                }

                vec3 applyToneMapping(vec3 color) {
                    if(toneMappingMode == 1) {
                        return reinhardToneMapping(color);
                    }
                    if(toneMappingMode == 2) {
                        return acesToneMapping(color);
                    }
                    return color;
                }

                void main() {
                    vec3 outColor = texelFetch(renderTexture, ivec2(gl_FragCoord.xy), 0).rgb;
                    outColor *= exposure;
                    outColor = applyToneMapping(outColor);
                    outColor = pow(outColor, vec3(1.0 / 2.2));
                    pc_fragColor = vec4(outColor, 1.0);
                }
                
            `
        });
    }
}




var $jw0R5 = parcelRequire("jw0R5");
const $7ccbd79909ba96e1$export$eabc71f011df675a = /* glsl */ `
    struct Triangle {
        vec3 p1, p2, p3;
        vec3 n1, n2, n3;
        vec2 uv1, uv2, uv3;
        float materialIndex;
    };

    struct Material {
        vec3 emissive;
        vec3 baseColor;
        float subsurface;
        float metallic;
        float specular;
        float specularTint;
        float roughness;
        float anisotropic;
        float sheen;
        float sheenTint;
        float clearcoat;
        float clearcoatGloss;
        float IOR;
        float transmission;
        float albedoTextureIndex;
        float normalTextureIndex;
        float metallicRoughnessTextureIndex;
        float aoTextureIndex;
        float emissiveTextureIndex;
        vec2 normalScale;
        float aoIntensity;
        float alpha;
        float alphaMode;
        float doubleSided;
    };

    struct BSDFSample {
        vec3 direction;
        vec3 weight;
        float pdf;
        uint flags;
        bool valid;
    };

    struct LightSample {
        vec3 direction;
        vec3 radiance;
        float distance;
        float pdf;
        uint flags;
        bool valid;
    };
    
    struct Ray {
        vec3 origin;
        vec3 direction;
    };

    struct RayHit {
        bool isHit;
        bool isInside;
        float distance;
        vec3 position;
        vec3 normal;
        vec3 geometricNormal;
        vec3 tangent;
        vec3 bitangent;
        vec2 uv;
        float materialIndex;
        vec3 rayDirec;
        Material material;
    };

    struct BVHNode {
        vec3 aa;
        vec3 bb;
        int isLeaf;
        int left;
        int right;
        int index;
        int size;
    };
`;


const $3755945b4f97493c$export$a2d8b23205c25948 = /* glsl */ `

    Material Gold() {
        Material material;
        material.emissive = vec3(0.0);
        material.baseColor = vec3(1.0, 0.766, 0.336);
        material.subsurface = 0.0;
        material.metallic = 1.0;
        material.specular = 0.1;
        material.specularTint = 1.0;
        material.roughness = 0.35;
        material.anisotropic = 0.0;
        material.sheen = 0.0;
        material.sheenTint = 0.0;
        material.clearcoat = 0.0;
        material.clearcoatGloss = 0.0;
        material.IOR = 0.0;
        material.transmission = 0.0;
        material.albedoTextureIndex = -1.0;
        material.normalTextureIndex = -1.0;
        material.metallicRoughnessTextureIndex = -1.0;
        material.aoTextureIndex = -1.0;
        material.emissiveTextureIndex = -1.0;
        material.normalScale = vec2(1.0);
        material.aoIntensity = 1.0;
        material.alpha = 1.0;
        material.alphaMode = 0.0;
        material.doubleSided = 0.0;
        return material;
    }

    Material Mirror() {
        Material material;
        material.emissive = vec3(0.0);
        material.baseColor = vec3(0.0);
        material.subsurface = 0.0;
        material.metallic = 0.0;
        material.specular = 1.0;
        material.specularTint = 1.0;
        material.roughness = 0.1;
        material.anisotropic = 0.0;
        material.sheen = 0.0;
        material.sheenTint = 0.0;
        material.clearcoat = 0.0;
        material.clearcoatGloss = 0.0;
        material.IOR = 0.0;
        material.transmission = 0.0;
        material.albedoTextureIndex = -1.0;
        material.normalTextureIndex = -1.0;
        material.metallicRoughnessTextureIndex = -1.0;
        material.aoTextureIndex = -1.0;
        material.emissiveTextureIndex = -1.0;
        material.normalScale = vec2(1.0);
        material.aoIntensity = 1.0;
        material.alpha = 1.0;
        material.alphaMode = 0.0;
        material.doubleSided = 0.0;
        return material;
    }

    Material DebugAlbedo() {
        Material material;
        material.emissive = vec3(0.0);
        material.baseColor = vec3(1.0);
        material.subsurface = 0.0;
        material.metallic = 0.0;
        material.specular = 0.5;
        material.specularTint = 0.0;
        material.roughness = 0.7;
        material.anisotropic = 0.0;
        material.sheen = 0.0;
        material.sheenTint = 0.0;
        material.clearcoat = 0.0;
        material.clearcoatGloss = 0.0;
        material.IOR = 1.5;
        material.transmission = 0.0;
        material.albedoTextureIndex = -1.0;
        material.normalTextureIndex = -1.0;
        material.metallicRoughnessTextureIndex = -1.0;
        material.aoTextureIndex = -1.0;
        material.emissiveTextureIndex = -1.0;
        material.normalScale = vec2(1.0);
        material.aoIntensity = 1.0;
        material.alpha = 1.0;
        material.alphaMode = 0.0;
        material.doubleSided = 0.0;
        return material;
    }
`;


const $cf826813f84aaca6$export$380958644dbbc22b = /* glsl */ `
    float sqr(float x) {
        return x * x;
    }

    void getTangent(vec3 N, inout vec3 tangent, inout vec3 bitangent) {
        vec3 helper = vec3(1, 0, 0);
        if(abs(N.x) > 0.999)
          helper = vec3(0, 0, 1);
        bitangent = normalize(cross(N, helper));
        tangent = normalize(cross(N, bitangent));
    }
`;


const $b65d887921898425$export$d2ca453b913dcdea = /* glsl */ `
    BVHNode getBVHNode(float i) {
        float width = bvhNodeDataTextureSize.x;
        // 3 slots
        ivec2 uv0 = ivec2(mod(texelsPerBVHNode * i + 0.0, width), texelsPerBVHNode * i / width);
        ivec2 uv1 = ivec2(mod(texelsPerBVHNode * i + 1.0, width), texelsPerBVHNode * i / width);
        ivec2 uv2 = ivec2(mod(texelsPerBVHNode * i + 2.0, width), texelsPerBVHNode * i / width);

        vec4 texel0 = texelFetch(bvhNodeDataTexture, uv0, 0);
        vec4 texel1 = texelFetch(bvhNodeDataTexture, uv1, 0);
        vec4 texel2 = texelFetch(bvhNodeDataTexture, uv2, 0);

        vec3 aa = texel0.xyz;
        vec3 bb = vec3(texel0.w, texel1.xy);
        // int id = int(texel1.z);
        int isLeaf = int(texel1.w);

        int left = int(texel2.x);
        int right = int(texel2.y);
        int index = int(texel2.z);
        int size = int(texel2.w);

        return BVHNode(aa, bb, isLeaf, left, right, index, size);
    }

    Triangle getTriangle(float i) {
        float width = triangleDataTextureSize.x;
      
        ivec2 uv0 = ivec2(mod(texelsPerTriangle * i + 0.0, width), texelsPerTriangle * i / width);
        ivec2 uv1 = ivec2(mod(texelsPerTriangle * i + 1.0, width), texelsPerTriangle * i / width);
        ivec2 uv2 = ivec2(mod(texelsPerTriangle * i + 2.0, width), texelsPerTriangle * i / width);
        ivec2 uv3 = ivec2(mod(texelsPerTriangle * i + 3.0, width), texelsPerTriangle * i / width);
        ivec2 uv4 = ivec2(mod(texelsPerTriangle * i + 4.0, width), texelsPerTriangle * i / width);
        ivec2 uv5 = ivec2(mod(texelsPerTriangle * i + 5.0, width), texelsPerTriangle * i / width);
      
        vec4 texel0 = texelFetch(triangleDataTexture, uv0, 0);
        vec4 texel1 = texelFetch(triangleDataTexture, uv1, 0);
        vec4 texel2 = texelFetch(triangleDataTexture, uv2, 0);
        vec4 texel3 = texelFetch(triangleDataTexture, uv3, 0);
        vec4 texel4 = texelFetch(triangleDataTexture, uv4, 0);
        vec4 texel5 = texelFetch(triangleDataTexture, uv5, 0);
      
        vec3 p1 = texel0.xyz;
        vec3 p2 = vec3(texel0.w, texel1.xy);
        vec3 p3 = vec3(texel1.zw, texel2.x);
        vec3 n1 = texel2.yzw;
        vec3 n2 = texel3.xyz;
        vec3 n3 = vec3(texel3.w, texel4.xy);
        vec2 t1 = texel4.zw;
        vec2 t2 = texel5.xy;
        vec2 t3 = texel5.zw;
        float materialIndex = texelFetch(triangleDataTexture, ivec2(mod(texelsPerTriangle * i + 6.0, width), texelsPerTriangle * i / width), 0).x;
        return Triangle(p1, p2, p3, n1, n2, n3, t1, t2, t3, materialIndex);
    }

    Material getSceneMaterial(float i) {
        float width = materialDataTextureSize.x;
        ivec2 uv0 = ivec2(mod(texelsPerMaterial * i + 0.0, width), texelsPerMaterial * i / width);
        ivec2 uv1 = ivec2(mod(texelsPerMaterial * i + 1.0, width), texelsPerMaterial * i / width);
        ivec2 uv2 = ivec2(mod(texelsPerMaterial * i + 2.0, width), texelsPerMaterial * i / width);
        ivec2 uv3 = ivec2(mod(texelsPerMaterial * i + 3.0, width), texelsPerMaterial * i / width);
        ivec2 uv4 = ivec2(mod(texelsPerMaterial * i + 4.0, width), texelsPerMaterial * i / width);

        vec4 texel0 = texelFetch(materialDataTexture, uv0, 0);
        vec4 texel1 = texelFetch(materialDataTexture, uv1, 0);
        vec4 texel2 = texelFetch(materialDataTexture, uv2, 0);
        vec4 texel3 = texelFetch(materialDataTexture, uv3, 0);
        vec4 texel4 = texelFetch(materialDataTexture, uv4, 0);

        Material material = DebugAlbedo();
        material.baseColor = texel0.rgb;
        material.roughness = texel0.w;
        material.metallic = texel1.x;
        material.emissive = texel1.yzw;
        material.albedoTextureIndex = texel2.x;
        material.normalTextureIndex = texel2.y;
        material.metallicRoughnessTextureIndex = texel2.z;
        material.emissiveTextureIndex = texel2.w;
        material.alpha = texel3.x;
        material.normalScale = texel3.yz;
        material.alphaMode = texel3.w;
        material.doubleSided = texel4.x;
        return material;
    }
`;


const $c5fcb2706de7c1bc$export$a6b5873e928946a9 = /* glsl */ `
    #define RNG_DOMAIN_PIXEL uint(1)
    #define RNG_DOMAIN_COSINE_HEMISPHERE uint(3)
    #define RNG_DOMAIN_GGX uint(5)
    #define RNG_DOMAIN_BRDF uint(6)
    #define RNG_DOMAIN_RUSSIAN_ROULETTE uint(7)

    uint updateSeed(float sampleCount) {
        uvec2 pixel = uvec2(ivec2(gl_FragCoord.xy));
        return (
            pixel.x * uint(1973) +
            pixel.y * uint(9277) +
            uint(sampleCount) * uint(26699) +
            uint(911)
        ) | uint(1);
    }

    void setRandomBounce(uint bounce) {
        rngBounce = bounce;
    }

    void beginRandomDomain(uint domain) {
        rngDomain = domain;
        rngDimensionCounter = uint(0);
    }
    
    void wang_hash(inout uint seed) {
        seed = uint(seed ^ uint(61)) ^ uint(seed >> uint(16));
        seed *= uint(9);
        seed = seed ^ (seed >> 4);
        seed *= uint(0x27d4eb2d);
        seed = seed ^ (seed >> 15);
    }
    
    float rand() {
        // Hash a stable per-pixel/per-sample seed with explicit bounce, domain,
        // and dimension indices so mirror-like BRDFs do not expose the structure
        // of one long correlated RNG stream as reflection-space rings.
        uint value = seed;
        value ^= (rngBounce + uint(1)) * uint(1597334677);
        value ^= (rngDomain + uint(1)) * uint(3812015801);
        value ^= (rngDimensionCounter + uint(1)) * uint(2798796415);
        wang_hash(value);
        rngDimensionCounter += uint(1);
        return float(value) / 4294967296.0;
    }
  
`;


const $456dcedcd1877dc6$export$a186db52eed6d40e = /* glsl */ `
    Ray createCameraRay() {
        setRandomBounce(uint(0));
        beginRandomDomain(RNG_DOMAIN_PIXEL);
        vec2 pixelOffset = vec2((rand() - 0.5), (rand() - 0.5));
        vec2 uv = ((gl_FragCoord.xy + pixelOffset) / resolution) * 2.0 - 1.0;
        vec4 clipPosition = vec4(uv, 1.0, 1.0);
        vec4 viewPosition = projectionMatrixInverse * clipPosition;
        viewPosition /= max(viewPosition.w, EPSILON);
        vec3 worldPosition = (matrixWorld * viewPosition).xyz;
        vec3 direction = normalize(worldPosition - cameraOrigin);
        return Ray(cameraOrigin, direction);
    }
    
    RayHit createHit() {
        RayHit hit;
        hit.isHit = false;
        hit.isInside = false;
        hit.distance = INFINITY;
        hit.position = vec3(INFINITY);
        hit.normal = vec3(0.0);
        hit.geometricNormal = vec3(0.0);
        hit.tangent = vec3(1.0, 0.0, 0.0);
        hit.bitangent = vec3(0.0, 1.0, 0.0);
        hit.uv = vec2(0.0);
        hit.materialIndex = 0.0;
        hit.rayDirec = vec3(0.0);
        if (materialPreset == 1) {
            hit.material = Gold();
        } else if (materialPreset == 2) {
            hit.material = Mirror();
        } else {
            hit.material = DebugAlbedo();
        }
        return hit;
    }

`;



const $0fd3ca6360088b63$export$65d2923ef7f45679 = /* glsl */ `
    #define STACK_SIZE 128
    #define MAX_BVH_STEPS 512
    #define MAX_TRIANGLES_PER_LEAF ${(0, $4f9e5cf7c14c121e$export$f4cd990fbac81a8e)}

    bool hitTriangle_MT97(Ray ray, vec3 vert0, vec3 vert1, vec3 vert2, inout float t, inout float u, inout float v) {
        vec3 edge1 = vert1 - vert0;
        vec3 edge2 = vert2 - vert0;
        vec3 pvec = cross(ray.direction, edge2);
        float det = dot(edge1, pvec);
        if(abs(det) < TRIANGLE_DETERMINANT_EPSILON) {
            return false;
        }

        float invDet = 1.0 / det;
        vec3 tvec = ray.origin - vert0;
        u = dot(tvec, pvec) * invDet;
        if(u < -TRIANGLE_BARYCENTRIC_EPSILON || u > 1.0 + TRIANGLE_BARYCENTRIC_EPSILON) {
            return false;
        }

        vec3 qvec = cross(tvec, edge1);
        v = dot(ray.direction, qvec) * invDet;
        if(v < -TRIANGLE_BARYCENTRIC_EPSILON || u + v > 1.0 + TRIANGLE_BARYCENTRIC_EPSILON) {
            return false;
        }

        t = dot(edge2, qvec) * invDet;
        return true;
    }

    void hitTriangle(Triangle tri, in Ray ray, inout RayHit hit) {
        float t, u, v;
        if(hitTriangle_MT97(ray, tri.p1, tri.p2, tri.p3, t, u, v)) {
        if(t > TRIANGLE_DISTANCE_EPSILON && t < hit.distance) {
            float w = 1.0 - u - v;
            vec3 edge1 = tri.p2 - tri.p1;
            vec3 edge2 = tri.p3 - tri.p1;
            vec3 geometricNormal = normalize(cross(edge1, edge2));
            vec2 deltaUV1 = tri.uv2 - tri.uv1;
            vec2 deltaUV2 = tri.uv3 - tri.uv1;
            float uvDeterminant = deltaUV1.x * deltaUV2.y - deltaUV1.y * deltaUV2.x;

            hit.isHit = true;
            hit.distance = t;
            hit.position = ray.origin + t * ray.direction;
            hit.normal = normalize(tri.n1 * w + tri.n2 * u + tri.n3 * v);
            hit.geometricNormal = geometricNormal;
            hit.uv = tri.uv1 * w + tri.uv2 * u + tri.uv3 * v;
            hit.materialIndex = tri.materialIndex;
            hit.rayDirec = ray.direction;

            if(abs(uvDeterminant) > EPSILON) {
                float inverseDeterminant = 1.0 / uvDeterminant;
                vec3 tangent = (edge1 * deltaUV2.y - edge2 * deltaUV1.y) * inverseDeterminant;
                tangent = normalize(tangent - hit.normal * dot(hit.normal, tangent));
                hit.tangent = tangent;
                hit.bitangent = normalize(cross(hit.normal, tangent)) * sign(uvDeterminant);
            } else {
                getTangent(hit.normal, hit.tangent, hit.bitangent);
            }

            if(dot(hit.geometricNormal, hit.rayDirec) > 0.0) {
                hit.isInside = true;
                hit.geometricNormal = -hit.geometricNormal;
                hit.normal = -hit.normal;
                hit.tangent = -hit.tangent;
                hit.bitangent = -hit.bitangent;
            }

            if(dot(hit.normal, hit.geometricNormal) < 0.0) {
                hit.normal = -hit.normal;
            }
        }
        }
    }
    
    void hitTriangles(int begin, int end, inout Ray ray, inout RayHit hit) {
        // leaf size is 8, keep loop bound compile-time constant for driver compatibility.
        for(int offset = 0; offset < MAX_TRIANGLES_PER_LEAF; ++offset) {
        int i = begin + offset;
        if(i > end) break;
        Triangle tri = getTriangle(float(i));
        hitTriangle(tri, ray, hit);
        }
    }
  
    float hitAABB(Ray ray, vec3 aa, vec3 bb) {
        vec3 origin = ray.origin;
        vec3 direction = ray.direction;
        float ox = origin.x;
        float oy = origin.y;
        float oz = origin.z;
        float dx = direction.x;
        float dy = direction.y;
        float dz = direction.z;
        float tx_min = -INFINITY;
        float ty_min = -INFINITY;
        float tz_min = -INFINITY;
        float tx_max = INFINITY;
        float ty_max = INFINITY;
        float tz_max = INFINITY;

        if(abs(dx) < EPSILON) {
            if(ox > bb.x || ox < aa.x) {
                return -1.0;
            }
        } else {
            float invDx = 1.0 / dx;
            float tx0 = (aa.x - ox) * invDx;
            float tx1 = (bb.x - ox) * invDx;
            tx_min = min(tx0, tx1);
            tx_max = max(tx0, tx1);
        }

        if(abs(dy) < EPSILON) {
            if(oy > bb.y || oy < aa.y) {
                return -1.0;
            }
        } else {
            float invDy = 1.0 / dy;
            float ty0 = (aa.y - oy) * invDy;
            float ty1 = (bb.y - oy) * invDy;
            ty_min = min(ty0, ty1);
            ty_max = max(ty0, ty1);
        }

        if(abs(dz) < EPSILON) {
            if(oz > bb.z || oz < aa.z) {
                return -1.0;
            }
        } else {
            float invDz = 1.0 / dz;
            float tz0 = (aa.z - oz) * invDz;
            float tz1 = (bb.z - oz) * invDz;
            tz_min = min(tz0, tz1);
            tz_max = max(tz0, tz1);
        }

        float t0 = max(tz_min, max(tx_min, ty_min));
        float t1 = min(tz_max, min(tx_max, ty_max));

        return (t1 >= t0) ? ((t0 > 0.0) ? (t0) : (t1)) : (-1.0);
    }

    void hitBVH(Ray ray, inout RayHit hit) {
        int stack[STACK_SIZE];
        int sp = 0;
        stack[sp++] = 0;
        // Use bounded iterations to avoid problematic unbounded while loops on some ANGLE backends.
        for(int iter = 0; iter < MAX_BVH_STEPS; ++iter) {
            if(sp <= 0) break;

            int index = stack[--sp];
            BVHNode node = getBVHNode(float(index));
            float d = hitAABB(ray, node.aa, node.bb);
        
            if(d >= 0.0 && d <= hit.distance) {
                if(node.isLeaf == 1) {
                    int start = node.index;
                    int end = node.index + node.size - 1;
                    hitTriangles(start, end, ray, hit);
                    continue;
                }
        
                int left = node.left;
                int right = node.right;
                float dLeft = INFINITY;
                float dRight = INFINITY;
                float maxDistance = hit.distance;
                if(left > 0) {
                    BVHNode leftNode = getBVHNode(float(left));
                    dLeft = hitAABB(ray, leftNode.aa, leftNode.bb);
                }
        
                if(right > 0) {
                    BVHNode rightNode = getBVHNode(float(right));
                    dRight = hitAABB(ray, rightNode.aa, rightNode.bb);
                }

                bool leftHit = dLeft >= 0.0 && dLeft <= maxDistance;
                bool rightHit = dRight >= 0.0 && dRight <= maxDistance;

                if(leftHit) {
                    if(sp < STACK_SIZE) stack[sp++] = left;
                }
                if(rightHit) {
                    if(sp < STACK_SIZE) stack[sp++] = right;
                }
            }
        }
    }

    RayHit hitScene(Ray ray) {
        RayHit bvhHit = createHit();
        hitBVH(ray, bvhHit);
        return bvhHit;
    }
`;


const $f29577c3ccebda6b$export$1b63d04ce55c929 = /* glsl */ `

    float SchlickFresnel(float u) {
        float m = clamp(1.0 - u, 0.0, 1.0);
        float m2 = m * m;
        return m2 * m2 * m; // pow(m,5)
    }
    
    float GTR1(float NdotH, float a) {
        if(a >= 1.0)
        return 1.0 / PI;
        float a2 = a * a;
        float t = 1.0 + (a2 - 1.0) * NdotH * NdotH;
        return (a2 - 1.0) / (PI * log(a2) * t);
    }
    
    float GTR2(float NdotH, float a) {
        float a2 = a * a;
        float t = 1.0 + (a2 - 1.0) * NdotH * NdotH;
        return a2 / (PI * t * t);
    }
    
    float GTR2_aniso(float NdotH, float HdotX, float HdotY, float ax, float ay) {
        return 1.0 / (PI * ax * ay * sqr(sqr(HdotX / ax) + sqr(HdotY / ay) + NdotH * NdotH));
    }

    float smithG_GGX(float NdotV, float alphaG) {
        float a = alphaG * alphaG;
        float b = NdotV * NdotV;
        return 1.0 / (NdotV + sqrt(a + b - a * b));
    }
    
    float smithG_GGX_aniso(float NdotV, float VdotX, float VdotY, float ax, float ay) {
        return 1.0 / (NdotV + sqrt(sqr(VdotX * ax) + sqr(VdotY * ay) + sqr(NdotV)));
    }

    float luminance(vec3 color) {
        return dot(color, vec3(0.2126, 0.7152, 0.0722));
    }

    vec3 BSDF_F0(in Material material) {
        vec3 baseColor = material.baseColor;
        float baseLuminance = 0.3 * baseColor.r + 0.6 * baseColor.g + 0.1 * baseColor.b;
        vec3 tint = (baseLuminance > 0.0) ? (baseColor / baseLuminance) : vec3(1.0);
        vec3 specularColor = material.specular * mix(vec3(1.0), tint, material.specularTint);
        return mix(0.08 * specularColor, baseColor, material.metallic);
    }

    float DiffusePDF(vec3 N, vec3 L) {
        return max(dot(N, L), 0.0) * ONE_OVER_PI;
    }

    float SpecularPDF(vec3 V, vec3 N, vec3 L, in Material material) {
        float NdotL = max(dot(N, L), 0.0);
        float NdotV = max(dot(N, V), 0.0);
        if(NdotL <= 0.0 || NdotV <= 0.0) {
            return 0.0;
        }

        vec3 H = normalize(V + L);
        float NdotH = max(dot(N, H), 0.0);
        float LdotH = max(dot(L, H), 0.0);
        if(NdotH <= 0.0 || LdotH <= 0.0) {
            return 0.0;
        }

        float alpha = max(material.roughness * material.roughness, 0.001);
        float distribution = GTR2(NdotH, alpha);
        return distribution * NdotH / max(4.0 * LdotH, EPSILON);
    }

    float BSDFSpecularSampleWeight(in Material material) {
        vec3 f0 = BSDF_F0(material);
        float diffuseWeight = (1.0 - material.metallic) * max(luminance(material.baseColor), 0.001);
        float specularWeight = max(luminance(f0), 0.001);
        return clamp(specularWeight / (diffuseWeight + specularWeight), 0.05, 0.95);
    }

    float BSDFPDF(vec3 V, vec3 N, vec3 L, in Material material) {
        float specularWeight = BSDFSpecularSampleWeight(material);
        float diffusePdf = DiffusePDF(N, L);
        float specularPdf = SpecularPDF(V, N, L, material);
        return (1.0 - specularWeight) * diffusePdf + specularWeight * specularPdf;
    }

    vec3 BSDFEvaluate(vec3 V, vec3 N, vec3 L, vec3 X, vec3 Y, in Material material) {

        float NdotL = dot(N, L);
        float NdotV = dot(N, V);
        if(NdotL <= 0.0 || NdotV <= 0.0) {
            return vec3(0.0);
        }
    
        vec3 halfVector = L + V;
        float halfVectorLengthSquared = dot(halfVector, halfVector);
        if(halfVectorLengthSquared <= EPSILON) {
            return vec3(0.0);
        }
        vec3 H = halfVector * inversesqrt(halfVectorLengthSquared);
        float NdotH = dot(N, H);
        float LdotH = dot(L, H);
    
        // albedo
        vec3 Cdlin = material.baseColor;
        float Cdlum = 0.3 * Cdlin.r + 0.6 * Cdlin.g + 0.1 * Cdlin.b;
        vec3 Ctint = (Cdlum > 0.0) ? (Cdlin / Cdlum) : (vec3(1.0));
        vec3 Cspec = material.specular * mix(vec3(1.0), Ctint, material.specularTint);
        vec3 Cspec0 = mix(0.08 * Cspec, Cdlin, material.metallic); 
        vec3 Csheen = mix(vec3(1.0), Ctint, material.sheenTint);   
    
        // diffuse
        float Fd90 = 0.5 + 2.0 * LdotH * LdotH * material.roughness;
        float FL = SchlickFresnel(NdotL);
        float FV = SchlickFresnel(NdotV);
        float Fd = mix(1.0, Fd90, FL) * mix(1.0, Fd90, FV);
    
        // subsurface scattering
        float Fss90 = LdotH * LdotH * material.roughness;
        float Fss = mix(1.0, Fss90, FL) * mix(1.0, Fss90, FV);
        float ss = 1.25 * (Fss * (1.0 / max(NdotL + NdotV, EPSILON) - 0.5) + 0.5);
    
        // specular -- uniso
        float alpha = max(material.roughness * material.roughness, 0.001);
        float Ds = GTR2(NdotH, alpha);
        float FH = SchlickFresnel(LdotH);
        vec3 Fs = mix(Cspec0, vec3(1), FH);
        float Gs = smithG_GGX(NdotL, material.roughness);
        Gs *= smithG_GGX(NdotV, material.roughness);
    
        // specular -- aniso
        // float aspect = sqrt(1.0 - material.anisotropic * 0.9);
        // float ax = max(0.001, sqr(material.roughness) / aspect);
        // float ay = max(0.001, sqr(material.roughness) * aspect);
        // float Ds = GTR2_aniso(NdotH, dot(H, X), dot(H, Y), ax, ay);
        // float FH = SchlickFresnel(LdotH);
        // vec3 Fs = mix(Cspec0, vec3(1), FH);
        // float Gs;
        // Gs = smithG_GGX_aniso(NdotL, dot(L, X), dot(L, Y), ax, ay);
        // Gs *= smithG_GGX_aniso(NdotV, dot(V, X), dot(V, Y), ax, ay);
    
        float Dr = GTR1(NdotH, mix(0.1, 0.001, material.clearcoatGloss));
        float Fr = mix(0.04, 1.0, FH);
        float Gr = smithG_GGX(NdotL, 0.25) * smithG_GGX(NdotV, 0.25);
    
        // sheen
        vec3 Fsheen = FH * material.sheen * Csheen;
    
        vec3 diffuse = (1.0 / PI) * mix(Fd, ss, material.subsurface) * Cdlin + Fsheen;
        vec3 clearcoat = vec3(0.25 * Gr * Fr * Dr * material.clearcoat);
        vec3 specular = Gs * Fs * Ds;

        return diffuse * (1.0 - material.metallic) + specular + clearcoat;
    
    }
`;


const $6fbc056546a007f2$export$21a3eccb8a1780eb = /* glsl */ `
    #define BSDF_EVENT_DIFFUSE uint(1)
    #define BSDF_EVENT_GLOSSY uint(2)
    #define BSDF_EVENT_REFLECTION uint(4)

    vec3 SampleCosineHemisphere() {
        beginRandomDomain(RNG_DOMAIN_COSINE_HEMISPHERE);
        float u1 = rand();
        float u2 = rand();
        float r = sqrt(u1);
        float phi = TWO_PI * u2;
        float x = r * cos(phi);
        float y = r * sin(phi);
        float z = sqrt(max(0.0, 1.0 - u1));
        return vec3(x, y, z);
    }

    vec3 toTangentFrame(vec3 v, vec3 tangent, vec3 bitangent, vec3 normal) {
        return normalize(v.x * tangent + v.y * bitangent + v.z * normal);
    }

    vec2 directionToEnvUV(vec3 direction) {
        float theta = asin(clamp(direction.y, -1.0, 1.0)) * ONE_OVER_PI + 0.5;
        float phi = atan(direction.z, direction.x) * ONE_OVER_TWO_PI + 0.5;
        return vec2(phi, theta);
    }

    vec3 SampleGGXHalfVector(float alpha, vec3 tangent, vec3 bitangent, vec3 normal) {
        beginRandomDomain(RNG_DOMAIN_GGX);
        float u1 = rand();
        float u2 = rand();
        float alphaSquared = alpha * alpha;
        float phi = TWO_PI * u1;
        float cosTheta = sqrt((1.0 - u2) / (1.0 + (alphaSquared - 1.0) * u2));
        float sinTheta = sqrt(max(0.0, 1.0 - cosTheta * cosTheta));
        vec3 localHalfVector = vec3(
            sinTheta * cos(phi),
            sinTheta * sin(phi),
            cosTheta
        );
        return toTangentFrame(localHalfVector, tangent, bitangent, normal);
    }

    BSDFSample SampleBSDF(
        vec3 viewDirection,
        vec3 surfaceNormal,
        vec3 tangent,
        vec3 bitangent,
        Material material
    ) {
        beginRandomDomain(RNG_DOMAIN_BRDF);
        float specularWeight = BSDFSpecularSampleWeight(material);
        bool sampleSpecular = rand() < specularWeight;
        vec3 sampledDirection;
        uint sampledFlags;

        if(sampleSpecular) {
            sampledFlags = BSDF_EVENT_GLOSSY | BSDF_EVENT_REFLECTION;
            float alpha = max(material.roughness * material.roughness, 0.001);
            vec3 halfVector = SampleGGXHalfVector(alpha, tangent, bitangent, surfaceNormal);
            sampledDirection = reflect(-viewDirection, halfVector);
            if(dot(sampledDirection, surfaceNormal) <= 0.0) {
                return BSDFSample(sampledDirection, vec3(0.0), 0.0, sampledFlags, false);
            }
        } else {
            sampledFlags = BSDF_EVENT_DIFFUSE | BSDF_EVENT_REFLECTION;
            sampledDirection = toTangentFrame(SampleCosineHemisphere(), tangent, bitangent, surfaceNormal);
        }

        float samplePdf = BSDFPDF(viewDirection, surfaceNormal, sampledDirection, material);
        float incomingCosine = max(dot(sampledDirection, surfaceNormal), 0.0);
        if(samplePdf <= EPSILON || incomingCosine <= 0.0) {
            return BSDFSample(sampledDirection, vec3(0.0), samplePdf, sampledFlags, false);
        }

        vec3 bsdf = BSDFEvaluate(
            viewDirection,
            surfaceNormal,
            sampledDirection,
            tangent,
            bitangent,
            material
        );
        vec3 sampleWeight = bsdf * incomingCosine / samplePdf;
        return BSDFSample(sampledDirection, sampleWeight, samplePdf, sampledFlags, true);
    }

`;


const $d9d9eb2560461d17$export$6ecadb6ed240d696 = /* glsl */ `
    #define LIGHT_EVENT_ENVIRONMENT uint(1)
    #define LIGHT_EVENT_SURFACE uint(2)

    LightSample EvaluateEnvironmentLight(Ray ray) {
        vec3 radiance = texture(hdrTexture, directionToEnvUV(ray.direction)).rgb;
        return LightSample(
            ray.direction,
            radiance,
            INFINITY,
            0.0,
            LIGHT_EVENT_ENVIRONMENT,
            true
        );
    }

    vec3 EvaluateSurfaceEmission(RayHit hit) {
        return hit.material.emissive;
    }
`;



const $d52c496644a540cd$export$a86fab198fa43d2c = /* glsl */ `
    #define MAX_BOUNCES ${(0, $4f9e5cf7c14c121e$export$5d4ce8383a4d99bb)}
    #define RUSSIAN_ROULETTE_START_DEPTH 3
    #define MAX_TRANSPARENT_SURFACE_STEPS ${(0, $4f9e5cf7c14c121e$export$b16373dbc4a645a0)}

    vec3 materialIdDebugColor(float materialIndex) {
        float id = materialIndex + 1.0;
        return fract(vec3(id * 0.37, id * 0.61, id * 0.83));
    }

    Material getSceneSurfaceMaterial(float materialIndex, vec2 uv, out vec3 baseColor, out float alpha) {
        Material sceneMaterial = getSceneMaterial(materialIndex);
        baseColor = sceneMaterial.baseColor;
        alpha = sceneMaterial.alpha;

        if(hasTextureIndex(sceneMaterial.albedoTextureIndex)) {
            vec4 albedoSample = sampleSceneAlbedoTexture(sceneMaterial.albedoTextureIndex, uv);
            baseColor *= albedoSample.rgb;
            alpha *= albedoSample.a;
        }

        return sceneMaterial;
    }

    void applyResolvedSceneMaterial(inout RayHit hit, Material sceneMaterial, vec3 resolvedBaseColor, float resolvedAlpha) {
        hit.material.alpha = resolvedAlpha;
        hit.material.alphaMode = sceneMaterial.alphaMode;
        hit.material.doubleSided = sceneMaterial.doubleSided;
        hit.material.baseColor = resolvedBaseColor;

        hit.material.roughness = clamp(sceneMaterial.roughness, 0.02, 1.0);
        if(hasTextureIndex(sceneMaterial.metallicRoughnessTextureIndex)) {
            hit.material.roughness *= sampleSceneMetallicRoughnessTexture(sceneMaterial.metallicRoughnessTextureIndex, hit.uv).g;
        }
        hit.material.roughness = clamp(hit.material.roughness, 0.02, 1.0);

        hit.material.metallic = clamp(sceneMaterial.metallic, 0.0, 1.0);
        if(hasTextureIndex(sceneMaterial.metallicRoughnessTextureIndex)) {
            hit.material.metallic *= sampleSceneMetallicRoughnessTexture(sceneMaterial.metallicRoughnessTextureIndex, hit.uv).b;
        }
        hit.material.metallic = clamp(hit.material.metallic, 0.0, 1.0);

        hit.material.emissive = sceneMaterial.emissive;
        if(hasTextureIndex(sceneMaterial.emissiveTextureIndex)) {
            hit.material.emissive *= sampleSceneEmissiveTexture(sceneMaterial.emissiveTextureIndex, hit.uv).rgb;
        }

        if(hasTextureIndex(sceneMaterial.normalTextureIndex)) {
            vec3 tangentSpaceNormal = sampleSceneNormalTexture(sceneMaterial.normalTextureIndex, hit.uv).xyz * 2.0 - 1.0;
            tangentSpaceNormal.xy *= sceneMaterial.normalScale;
            tangentSpaceNormal = normalize(tangentSpaceNormal);
            hit.normal = normalize(
                hit.tangent * tangentSpaceNormal.x +
                hit.bitangent * tangentSpaceNormal.y +
                hit.normal * tangentSpaceNormal.z
            );
            if(dot(hit.normal, hit.geometricNormal) < 0.0) {
                hit.normal = -hit.normal;
            }
        }

        if(dot(hit.normal, -hit.rayDirec) < 0.0) {
            hit.normal = -hit.normal;
        }
    }

    RayHit traceScene(Ray ray, inout vec3 transmissionFilter) {
        Ray currentRay;
        currentRay.origin = ray.origin;
        currentRay.direction = ray.direction;

        if(materialPreset != 0) {
            return hitScene(currentRay);
        }

        for(int surfaceStep = 0; surfaceStep < MAX_TRANSPARENT_SURFACE_STEPS; ++surfaceStep) {
            if(surfaceStep >= maxTransparentSteps) {
                break;
            }

            RayHit hit = hitScene(currentRay);
            if(!hit.isHit) {
                return hit;
            }

            vec3 surfaceBaseColor = vec3(1.0);
            float surfaceAlpha = 1.0;
            Material sceneMaterial = getSceneSurfaceMaterial(hit.materialIndex, hit.uv, surfaceBaseColor, surfaceAlpha);

            if(sceneMaterial.alphaMode >= 0.5 && sceneMaterial.alphaMode < 1.5 && surfaceAlpha < 0.5) {
                currentRay.origin = hit.position + currentRay.direction * RAY_OFFSET_EPSILON * 2.0;
            } else if(sceneMaterial.alphaMode >= 1.5 && surfaceAlpha < 1.0 - EPSILON) {
                transmissionFilter *= mix(vec3(1.0), surfaceBaseColor, clamp(surfaceAlpha, 0.0, 1.0));
                currentRay.origin = hit.position + currentRay.direction * RAY_OFFSET_EPSILON * 2.0;
            } else {
                applyResolvedSceneMaterial(hit, sceneMaterial, surfaceBaseColor, surfaceAlpha);
                return hit;
            }
        }

        return createHit();
    }

    vec3 renderDebugHit(
        RayHit hit,
        vec3 materialBase,
        float materialRoughness,
        float materialMetallic,
        vec3 materialEmissive
    ) {
        if(debugMode == 1) {
            return hit.material.baseColor;
        }
        if(debugMode == 2) {
            return vec3(hit.uv, 0.0);
        }
        if(debugMode == 3) {
            return vec3(fract(hit.uv), 0.0);
        }
        if(debugMode == 4) {
            float checker = mod(floor(hit.uv.x * 20.0) + floor(hit.uv.y * 20.0), 2.0);
            return vec3(checker);
        }
        if(debugMode == 5) {
            return materialIdDebugColor(hit.materialIndex);
        }
        if(debugMode == 6) {
            return materialBase;
        }
        if(debugMode == 7) {
            return vec3(materialRoughness);
        }
        if(debugMode == 8) {
            return vec3(materialMetallic);
        }
        if(debugMode == 9) {
            return materialEmissive;
        }

        vec3 viewDirection = -hit.rayDirec;
        vec3 surfaceGeometricNormal = hit.geometricNormal;

        if(debugMode == 10) {
            float facing = abs(dot(surfaceGeometricNormal, viewDirection));
            return materialBase * max(facing, 0.15);
        }
        if(debugMode == 11) {
            return surfaceGeometricNormal * 0.5 + 0.5;
        }
        if(debugMode == 12) {
            // FlightHelmet's HoseMat is material 0 in the source glTF and
            // remains first under the current SceneGenerator traversal order.
            return hit.materialIndex < 0.5 ? vec3(1.0, 0.1, 0.1) : vec3(0.02);
        }
        if(debugMode == 13) {
            float normalizedDistance = clamp(hit.distance / 2.0, 0.0, 1.0);
            return vec3(normalizedDistance);
        }

        return materialBase;
    }

    vec3 pathTrace() {
        Ray ray = createCameraRay();
        vec3 radiance = vec3(0.0);
        vec3 throughput = vec3(1.0);

        // maxBounce is the number of scattering events. The extra terminal
        // intersection records environment or emissive radiance after the last event.
        for(int depth = 0; depth <= MAX_BOUNCES; depth++) {
            if(depth > maxBounce) {
                break;
            }
            setRandomBounce(uint(depth));

            vec3 surfaceFilter = vec3(1.0);
            RayHit hit = traceScene(ray, surfaceFilter);
            throughput *= surfaceFilter;

            if(!hit.isHit) {
                LightSample environmentLight = EvaluateEnvironmentLight(ray);
                radiance += throughput * environmentLight.radiance;
                break;
            }

            if(debugMode != 0) {
                return renderDebugHit(
                    hit,
                    hit.material.baseColor,
                    hit.material.roughness,
                    hit.material.metallic,
                    hit.material.emissive
                );
            }

            radiance += throughput * EvaluateSurfaceEmission(hit);
            if(depth >= maxBounce) {
                break;
            }

            vec3 viewDirection = -hit.rayDirec;
            vec3 surfaceGeometricNormal = hit.geometricNormal;
            vec3 surfaceNormal = hit.normal;
            vec3 tangent = hit.tangent;
            vec3 bitangent = hit.bitangent;

            // Thin double-sided geometry is more stable when the sampling hemisphere
            // is anchored to the geometric normal instead of the perturbed normal map.
            if(hit.material.doubleSided > 0.5) {
                surfaceNormal = surfaceGeometricNormal;
                getTangent(surfaceNormal, tangent, bitangent);
            }

            BSDFSample bsdfSample = SampleBSDF(
                viewDirection,
                surfaceNormal,
                tangent,
                bitangent,
                hit.material
            );
            if(!bsdfSample.valid || dot(bsdfSample.direction, surfaceGeometricNormal) <= 0.0) {
                break;
            }
            throughput *= bsdfSample.weight;

            float maxThroughput = max(throughput.r, max(throughput.g, throughput.b));
            if(maxThroughput <= 0.0) {
                break;
            }

            if(depth >= RUSSIAN_ROULETTE_START_DEPTH) {
                beginRandomDomain(RNG_DOMAIN_RUSSIAN_ROULETTE);
                float survivalProb = min(maxThroughput, 0.95);
                if(rand() >= survivalProb) {
                    break;
                }
                throughput /= survivalProb;
            }

            ray.origin = hit.position + surfaceGeometricNormal * RAY_OFFSET_EPSILON;
            ray.direction = bsdfSample.direction;
        }

        return radiance;
    }
    
    void main(void) {
    
        seed = updateSeed(samples);
        
        vec3 sampleRadiance = pathTrace();
        vec3 accumulatedRadiance = texelFetch(outTexture, ivec2(gl_FragCoord.xy), 0).rgb;
        float accumulationWeight = 1.0 / (1.0 + samples);
        pc_fragColor = vec4(mix(accumulatedRadiance, sampleRadiance, accumulationWeight), 1.0);
    }
`;


class $145ab198af87850a$export$357223536b51a4a3 extends (0, $0bbda9d3fe0392ad$export$f1ac3a587b6cbb5d) {
    constructor(){
        super({
            glslVersion: (0, $jw0R5.GLSL3),
            transparent: false,
            depthWrite: false,
            depthTest: false,
            uniforms: {
                samples: {
                    type: "f",
                    value: null
                },
                maxBounce: {
                    type: "i",
                    value: null
                },
                resolution: {
                    type: "v2",
                    value: null
                },
                cameraOrigin: {
                    type: "v3",
                    value: null
                },
                matrixWorld: {
                    type: "m4",
                    value: null
                },
                projectionMatrixInverse: {
                    type: "m4",
                    value: null
                },
                texelsPerTriangle: {
                    type: "f",
                    value: null
                },
                texelsPerBVHNode: {
                    type: "f",
                    value: null
                },
                texelsPerMaterial: {
                    type: "f",
                    value: null
                },
                triangleDataTexture: {
                    type: "t",
                    value: null
                },
                triangleDataTextureSize: {
                    type: "v2",
                    value: null
                },
                bvhNodeDataTexture: {
                    type: "t",
                    value: null
                },
                bvhNodeDataTextureSize: {
                    type: "v2",
                    value: null
                },
                materialDataTexture: {
                    type: "t",
                    value: null
                },
                materialDataTextureSize: {
                    type: "v2",
                    value: null
                },
                outTexture: {
                    type: "t",
                    value: null
                },
                sceneAlbedoTextureArray: {
                    type: 't',
                    value: null
                },
                sceneNormalTextureArray: {
                    type: 't',
                    value: null
                },
                sceneMetallicRoughnessTextureArray: {
                    type: 't',
                    value: null
                },
                sceneEmissiveTextureArray: {
                    type: 't',
                    value: null
                },
                materialPreset: {
                    type: "i",
                    value: 0
                },
                debugMode: {
                    type: "i",
                    value: 0
                },
                hdrTexture: {
                    type: "t",
                    value: null
                },
                maxTransparentSteps: {
                    type: "i",
                    value: 2
                }
            },
            vertexShader: /* glsl */ `
                void main() {
                    gl_Position = vec4(position, 1.0);
                }
            `,
            fragmentShader: /* glsl */ `
                #ifdef GL_FRAGMENT_PRECISION_HIGH
                    precision highp float;
                #else
                    precision mediump float;
                #endif

                #define PI 3.1415926535897
                #define TWO_PI 6.283185307179
                #define ONE_OVER_PI      0.31830988618
                #define ONE_OVER_TWO_PI  0.15915494309
                #define INFINITY 1000000.0
                #define EPSILON 0.00001
                // Keep determinant tolerance much smaller than barycentric / distance tolerances:
                // small triangles like FlightHelmet's hoses produce small but still valid det values.
                #define TRIANGLE_DETERMINANT_EPSILON 0.0000001
                #define TRIANGLE_BARYCENTRIC_EPSILON 0.00001
                #define TRIANGLE_DISTANCE_EPSILON 0.00001
                #define AABB_EPSILON 0.00001
                #define RAY_OFFSET_EPSILON 0.0002

                out highp vec4 pc_fragColor;
                uniform float samples;
                uniform int maxBounce;
                uniform vec2 resolution;
                uniform vec3 cameraOrigin;
                uniform mat4 matrixWorld;
                uniform mat4 projectionMatrixInverse;
                uniform sampler2D hdrTexture;
                uniform sampler2D triangleDataTexture;
                uniform sampler2D bvhNodeDataTexture;
                uniform sampler2D materialDataTexture;
                uniform sampler2D outTexture;
                uniform highp sampler2DArray sceneAlbedoTextureArray;
                uniform highp sampler2DArray sceneNormalTextureArray;
                uniform highp sampler2DArray sceneMetallicRoughnessTextureArray;
                uniform highp sampler2DArray sceneEmissiveTextureArray;
                uniform int materialPreset;
                uniform int debugMode;
                uniform int maxTransparentSteps;

                uniform float texelsPerTriangle;
                uniform float texelsPerBVHNode;
                uniform float texelsPerMaterial;
                uniform vec2 triangleDataTextureSize;
                uniform vec2 bvhNodeDataTextureSize;
                uniform vec2 materialDataTextureSize;

                uint seed;
                uint rngDomain;
                uint rngDimensionCounter;
                uint rngBounce;

                ${(0, $7ccbd79909ba96e1$export$eabc71f011df675a)}
                ${(0, $3755945b4f97493c$export$a2d8b23205c25948)}
                ${(0, $cf826813f84aaca6$export$380958644dbbc22b)}
                ${(0, $b65d887921898425$export$d2ca453b913dcdea)}
                ${(0, $c5fcb2706de7c1bc$export$a6b5873e928946a9)}
                ${(0, $456dcedcd1877dc6$export$a186db52eed6d40e)}
                ${(0, $0fd3ca6360088b63$export$65d2923ef7f45679)}
                ${(0, $f29577c3ccebda6b$export$1b63d04ce55c929)}
                ${(0, $6fbc056546a007f2$export$21a3eccb8a1780eb)}

                bool hasTextureIndex(float textureIndex) {
                    return textureIndex >= 0.0;
                }

                vec4 sampleSceneAlbedoTexture(float textureIndex, vec2 uv) {
                    return texture(sceneAlbedoTextureArray, vec3(uv, textureIndex));
                }

                vec4 sampleSceneNormalTexture(float textureIndex, vec2 uv) {
                    return texture(sceneNormalTextureArray, vec3(uv, textureIndex));
                }

                vec4 sampleSceneMetallicRoughnessTexture(float textureIndex, vec2 uv) {
                    return texture(sceneMetallicRoughnessTextureArray, vec3(uv, textureIndex));
                }

                vec4 sampleSceneEmissiveTexture(float textureIndex, vec2 uv) {
                    return texture(sceneEmissiveTextureArray, vec3(uv, textureIndex));
                }

                ${(0, $d9d9eb2560461d17$export$6ecadb6ed240d696)}
                ${(0, $d52c496644a540cd$export$a86fab198fa43d2c)}
            `
        });
        this.uniforms.cameraOrigin.value = new (0, $jw0R5.Vector3)();
        this.uniforms.materialDataTextureSize.value = new (0, $jw0R5.Vector2)(1, 1);
    }
}



function* $bc45d8f57c09d163$var$renderTask() {
    while(true){
        const { renderer: renderer, camera: camera, traceScene: traceScene, traceCamera: traceCamera, pathTracingMaterial: pathTracingMaterial, outputMaterial: outputMaterial } = this;
        camera.updateMatrixWorld();
        camera.updateProjectionMatrix();
        pathTracingMaterial.samples = this.samples;
        camera.getWorldPosition(this.cameraOrigin);
        pathTracingMaterial.cameraOrigin = this.cameraOrigin;
        pathTracingMaterial.matrixWorld = camera.matrixWorld;
        pathTracingMaterial.projectionMatrixInverse = camera.projectionMatrixInverse;
        pathTracingMaterial.outTexture = this.outRenderTarget.texture;
        renderer.setRenderTarget(this.traceRenderTarget);
        renderer.render(traceScene, traceCamera);
        outputMaterial.renderTexture = this.traceRenderTarget.texture;
        renderer.setRenderTarget(null);
        this.outputQuad.render(renderer);
        [this.traceRenderTarget, this.outRenderTarget] = [
            this.outRenderTarget,
            this.traceRenderTarget
        ];
        this.samples++;
        yield;
    }
}
function $bc45d8f57c09d163$var$createFallbackLayer(rgba) {
    return new Uint8Array(rgba);
}
function $bc45d8f57c09d163$var$getTextureImageSize(texture) {
    const image = texture?.image;
    if (!image) return null;
    if (Number.isFinite(image.width) && Number.isFinite(image.height)) return {
        width: image.width,
        height: image.height
    };
    return null;
}
function $bc45d8f57c09d163$var$extractTextureLayer(texture, width, height) {
    const image = texture?.image;
    if (!image) return null;
    try {
        const canvas = typeof OffscreenCanvas !== 'undefined' ? new OffscreenCanvas(width, height) : document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', {
            willReadFrequently: true
        });
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);
        const { data: data } = context.getImageData(0, 0, width, height);
        return new Uint8Array(data.buffer.slice(0));
    } catch (error) {
        console.warn('[PathTracing] Failed to extract texture layer.', texture, error);
        return null;
    }
}
function $bc45d8f57c09d163$var$buildTextureArray(textures, colorSpace, fallbackRgba) {
    const validTextures = (textures || []).filter(Boolean);
    const layers = validTextures.length;
    if (layers === 0) {
        const texture = new (0, $jw0R5.DataArrayTexture)($bc45d8f57c09d163$var$createFallbackLayer(fallbackRgba), 1, 1, 1);
        texture.format = (0, $jw0R5.RGBAFormat);
        texture.type = (0, $jw0R5.UnsignedByteType);
        texture.minFilter = (0, $jw0R5.LinearFilter);
        texture.magFilter = (0, $jw0R5.LinearFilter);
        texture.wrapS = (0, $jw0R5.ClampToEdgeWrapping);
        texture.wrapT = (0, $jw0R5.ClampToEdgeWrapping);
        texture.generateMipmaps = false;
        texture.colorSpace = colorSpace;
        texture.needsUpdate = true;
        return texture;
    }
    let width = 1;
    let height = 1;
    validTextures.forEach((texture)=>{
        const size = $bc45d8f57c09d163$var$getTextureImageSize(texture);
        if (!size) return;
        width = Math.max(width, size.width);
        height = Math.max(height, size.height);
    });
    const layerSize = width * height * 4;
    const data = new Uint8Array(layerSize * layers);
    validTextures.forEach((texture, layerIndex)=>{
        const layerData = $bc45d8f57c09d163$var$extractTextureLayer(texture, width, height);
        if (!layerData) return;
        data.set(layerData, layerIndex * layerSize);
    });
    const texture = new (0, $jw0R5.DataArrayTexture)(data, width, height, layers);
    texture.format = (0, $jw0R5.RGBAFormat);
    texture.type = (0, $jw0R5.UnsignedByteType);
    texture.minFilter = (0, $jw0R5.LinearMipmapLinearFilter);
    texture.magFilter = (0, $jw0R5.LinearFilter);
    texture.wrapS = (0, $jw0R5.RepeatWrapping);
    texture.wrapT = (0, $jw0R5.RepeatWrapping);
    texture.generateMipmaps = true;
    texture.colorSpace = colorSpace;
    texture.needsUpdate = true;
    return texture;
}
class $bc45d8f57c09d163$export$85ed4a3796ccccf7 {
    constructor(renderer, scene, camera){
        this.renderer = renderer;
        this.scene = scene;
        this.camera = camera;
        this.task = null;
        this.samples = 0;
        this.ready = false;
        this.disposed = false;
        this.cameraOrigin = new (0, $jw0R5.Vector3)();
        this.rasterFallbackRenderer = null;
        this.init();
    }
    init() {
        this.outRenderTarget = new (0, $jw0R5.WebGLRenderTarget)(1, 1, {
            format: (0, $jw0R5.RGBAFormat),
            type: (0, $jw0R5.FloatType),
            magFilter: (0, $jw0R5.NearestFilter),
            minFilter: (0, $jw0R5.NearestFilter)
        });
        this.traceRenderTarget = new (0, $jw0R5.WebGLRenderTarget)(1, 1, {
            format: (0, $jw0R5.RGBAFormat),
            type: (0, $jw0R5.FloatType),
            magFilter: (0, $jw0R5.NearestFilter),
            minFilter: (0, $jw0R5.NearestFilter)
        });
        this.pathTracingQuad = new (0, $jw0R5.Mesh)(new (0, $jw0R5.PlaneGeometry)(2, 2), new (0, $145ab198af87850a$export$357223536b51a4a3)());
        this.pathTracingQuad.frustumCulled = false;
        this.traceScene = new (0, $jw0R5.Scene)();
        this.traceCamera = new (0, $jw0R5.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
        this.outputQuad = new (0, $d0e64fd1c8ab14ed$export$3983474c8e6e978b)(new (0, $9740c2581f87cab8$export$59f4d53140b73aac)());
        this.traceScene.add(this.pathTracingQuad);
        this.pathTracingMaterial = this.pathTracingQuad.material;
        this.outputMaterial = this.outputQuad.material;
        this._setConstants();
        this._setRenderTexture();
        this._setSceneTextureArrays();
    }
    // set constants used inside shader
    _setConstants() {
        this.pathTracingMaterial.texelsPerTriangle = (0, $4f9e5cf7c14c121e$export$f8d507d96c342ed1);
        this.pathTracingMaterial.texelsPerBVHNode = (0, $4f9e5cf7c14c121e$export$d393949a0b2bdcc6);
        this.pathTracingMaterial.texelsPerMaterial = (0, $4f9e5cf7c14c121e$export$f975357ddbdd6976);
    }
    // set full screen textures during rendering
    _setRenderTexture() {
        this.pathTracingMaterial.outTexture = this.outRenderTarget.texture;
        this.outputMaterial.renderTexture = this.traceRenderTarget.texture;
    }
    _setSceneTextureArrays() {
        this.sceneTextureArrays = {
            albedo: null,
            normal: null,
            metallicRoughness: null,
            emissive: null
        };
    }
    _disposeSceneTextureArrays() {
        Object.values(this.sceneTextureArrays).forEach((texture)=>{
            if (texture) texture.dispose();
        });
        this._setSceneTextureArrays();
        this.pathTracingMaterial.sceneAlbedoTextureArray = null;
        this.pathTracingMaterial.sceneNormalTextureArray = null;
        this.pathTracingMaterial.sceneMetallicRoughnessTextureArray = null;
        this.pathTracingMaterial.sceneEmissiveTextureArray = null;
    }
    _assignSceneTextureArray(key, textures, colorSpace, fallbackRgba) {
        const textureArray = $bc45d8f57c09d163$var$buildTextureArray(textures, colorSpace, fallbackRgba);
        this.sceneTextureArrays[key] = textureArray;
        return textureArray;
    }
    _setSceneMaterialTextureArrays(textures) {
        this._disposeSceneTextureArrays();
        this.pathTracingMaterial.sceneAlbedoTextureArray = this._assignSceneTextureArray('albedo', textures?.albedo, (0, $jw0R5.SRGBColorSpace), [
            255,
            255,
            255,
            255
        ]);
        this.pathTracingMaterial.sceneNormalTextureArray = this._assignSceneTextureArray('normal', textures?.normal, (0, $jw0R5.NoColorSpace), [
            128,
            128,
            255,
            255
        ]);
        this.pathTracingMaterial.sceneMetallicRoughnessTextureArray = this._assignSceneTextureArray('metallicRoughness', textures?.metallicRoughness, (0, $jw0R5.NoColorSpace), [
            255,
            255,
            255,
            255
        ]);
        this.pathTracingMaterial.sceneEmissiveTextureArray = this._assignSceneTextureArray('emissive', textures?.emissive, (0, $jw0R5.SRGBColorSpace), [
            255,
            255,
            255,
            255
        ]);
    }
    _supportsTextureArrays() {
        return this.renderer.capabilities.isWebGL2;
    }
    // set bounces
    setBounce(maxBounce) {
        this.pathTracingMaterial.maxBounce = Math.max(1, Math.min(maxBounce, (0, $4f9e5cf7c14c121e$export$5d4ce8383a4d99bb)));
    }
    setTransparentSteps(stepCount) {
        this.pathTracingMaterial.maxTransparentSteps = Math.max(1, Math.min(stepCount, (0, $4f9e5cf7c14c121e$export$b16373dbc4a645a0)));
    }
    // set hdr texture
    setHdrTexture(texture) {
        texture.minFilter = (0, $jw0R5.LinearFilter);
        texture.magFilter = (0, $jw0R5.LinearFilter);
        texture.generateMipmaps = false;
        this.pathTracingMaterial.hdrTexture = texture;
    }
    setDebugMode(mode) {
        this.pathTracingMaterial.debugMode = mode;
    }
    setMaterialPreset(preset) {
        this.pathTracingMaterial.materialPreset = preset;
    }
    setOutputToneMapping(mode) {
        this.outputMaterial.toneMappingMode = mode;
    }
    setOutputExposure(exposure) {
        this.outputMaterial.exposure = exposure;
    }
    setScene(compiledScene) {
        if (!compiledScene || compiledScene.disposed) throw new Error('[PathTracing] setScene requires a live CompiledScene.');
        this.setDataTexture(compiledScene.triangle, compiledScene.bvh, compiledScene.material);
    }
    // set Data texture
    setDataTexture(triangle, bvh, material) {
        const pathTracingMaterial = this.pathTracingMaterial;
        pathTracingMaterial.triangleDataTexture = triangle.dataTexture;
        pathTracingMaterial.triangleDataTextureSize = {
            x: triangle.textureWidth,
            y: triangle.textureHeight
        };
        pathTracingMaterial.bvhNodeDataTexture = bvh.dataTexture;
        pathTracingMaterial.bvhNodeDataTextureSize = {
            x: bvh.textureWidth,
            y: bvh.textureHeight
        };
        pathTracingMaterial.materialDataTexture = material.dataTexture;
        pathTracingMaterial.materialDataTextureSize = {
            x: material.textureWidth,
            y: material.textureHeight
        };
        if (!this._supportsTextureArrays()) {
            console.warn('[PathTracing] Texture arrays require WebGL2. Scene materials will fall back to factors only.');
            this._disposeSceneTextureArrays();
            this.ready = true;
            return;
        }
        this._setSceneMaterialTextureArrays(material.textures);
        this.ready = true;
    }
    setSize(width, height) {
        width = ~~width;
        height = ~~height;
        if (this.traceRenderTarget.width === width && this.traceRenderTarget.height === height) return;
        this.renderer.setSize(width, height);
        this.traceRenderTarget.setSize(width, height);
        this.outRenderTarget.setSize(width, height);
        this.pathTracingMaterial.resolution = {
            x: width,
            y: height
        };
    }
    update() {
        if (this.disposed) return;
        if (!this.task) this.task = $bc45d8f57c09d163$var$renderTask.call(this);
        this.task.next();
    }
    setRasterFallbackRenderer(callback) {
        this.rasterFallbackRenderer = callback ?? null;
    }
    renderRasterFallback() {
        if (!this.rasterFallbackRenderer) return false;
        this.rasterFallbackRenderer({
            renderer: this.renderer,
            scene: this.scene,
            camera: this.camera,
            pathTracer: this
        });
        return true;
    }
    setReady(ready) {
        this.ready = ready;
    }
    isReady() {
        return this.ready;
    }
    reset() {
        const currentRenderTarget = this.renderer.getRenderTarget();
        const clearColor = this.renderer.getClearColor(new (0, $jw0R5.Color)());
        const clearAlpha = this.renderer.getClearAlpha();
        this.samples = 0;
        this.renderer.setClearColor(0x000000, 0);
        this.renderer.setRenderTarget(this.traceRenderTarget);
        this.renderer.clear();
        this.renderer.setRenderTarget(this.outRenderTarget);
        this.renderer.clear();
        this.renderer.setClearColor(clearColor, clearAlpha);
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.task = null;
        this.ready = false;
        this.rasterFallbackRenderer = null;
        this._disposeSceneTextureArrays();
        this.traceScene.remove(this.pathTracingQuad);
        this.pathTracingQuad.geometry.dispose();
        this.pathTracingMaterial.dispose();
        this.outputMaterial.dispose();
        this.outputQuad.dispose();
        this.traceRenderTarget.dispose();
        this.outRenderTarget.dispose();
    }
}



var $6BOAB = parcelRequire("6BOAB");
const $a6d7bc8f2acef6fd$var$assetUrl = (0, $6BOAB.getAssetURL)();
const $a6d7bc8f2acef6fd$var$modelAssetPaths = {
    DamagedHelmet: 'https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/main/2.0/DamagedHelmet/glTF/DamagedHelmet.gltf',
    FlightHelmet: 'https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/main/2.0/FlightHelmet/glTF/FlightHelmet.gltf',
    SciFiHelmet: 'https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/main/2.0/SciFiHelmet/glTF/SciFiHelmet.gltf'
};
const $a6d7bc8f2acef6fd$var$modelOptions = {
    DamagedHelmet: 'DamagedHelmet',
    FlightHelmet: 'FlightHelmet',
    SciFiHelmet: 'SciFiHelmet'
};
const $a6d7bc8f2acef6fd$var$hdrAssetPaths = {
    KiaraNoon: 'hdrs/kiara_5_noon_2k.hdr',
    Daytime: 'hdrs/daytime.hdr'
};
const $a6d7bc8f2acef6fd$var$hdrOptions = {
    KiaraNoon: 'KiaraNoon',
    Daytime: 'Daytime'
};
const $a6d7bc8f2acef6fd$var$info = document.querySelector("#info");
let $a6d7bc8f2acef6fd$var$renderer, $a6d7bc8f2acef6fd$var$scene, $a6d7bc8f2acef6fd$var$camera, $a6d7bc8f2acef6fd$var$controls, $a6d7bc8f2acef6fd$var$stats, $a6d7bc8f2acef6fd$var$pane;
let $a6d7bc8f2acef6fd$var$pathTracer;
let $a6d7bc8f2acef6fd$var$pmremGenerator;
let $a6d7bc8f2acef6fd$var$currentModel = null;
let $a6d7bc8f2acef6fd$var$currentEnvironmentBackground = null;
let $a6d7bc8f2acef6fd$var$currentEnvironmentTarget = null;
let $a6d7bc8f2acef6fd$var$currentCompiledScene = null;
let $a6d7bc8f2acef6fd$var$loadGeneration = 0;
let $a6d7bc8f2acef6fd$var$currentModelHasAlbedoTexture = false;
let $a6d7bc8f2acef6fd$var$resumeTraceTimer = null;
const $a6d7bc8f2acef6fd$var$BG_COLOR = 0x333333;
const $a6d7bc8f2acef6fd$var$sceneParams = {
    model: 'DamagedHelmet',
    environment: 'Daytime'
};
const $a6d7bc8f2acef6fd$var$materialParams = {
    material: 'off',
    debugMode: 'lit',
    materialIndexing: 'off'
};
const $a6d7bc8f2acef6fd$var$renderParams = {
    bounceCount: 2,
    transparentSteps: 1,
    renderScale: 1,
    rasterFallback: true,
    interactionResumeDelayMs: 500,
    toneMapping: 'none',
    exposure: 1.0
};
const $a6d7bc8f2acef6fd$var$debugModeOptions = {
    Off: 'lit',
    Albedo: 'albedo',
    UV: 'uv',
    'UV Fract': 'uvFract',
    Checker: 'checker',
    Facing: 'facing',
    'Geo Normal': 'geoNormal',
    'Hose Mask': 'hoseMask',
    'Hit Dist': 'hitDistance'
};
const $a6d7bc8f2acef6fd$var$materialIndexingOptions = {
    Off: 'off',
    'Material ID': 'materialId',
    'Material Base': 'materialBase',
    'Material Roughness': 'materialRoughness',
    'Material Metalness': 'materialMetalness',
    'Material Emissive': 'materialEmissive'
};
const $a6d7bc8f2acef6fd$var$debugModeValues = {
    lit: 0,
    albedo: 1,
    uv: 2,
    uvFract: 3,
    checker: 4,
    materialId: 5,
    materialBase: 6,
    materialRoughness: 7,
    materialMetalness: 8,
    materialEmissive: 9,
    facing: 10,
    geoNormal: 11,
    hoseMask: 12,
    hitDistance: 13
};
const $a6d7bc8f2acef6fd$var$materialOptions = {
    Off: 'off',
    Gold: 'gold',
    Mirror: 'mirror'
};
const $a6d7bc8f2acef6fd$var$materialPresetValues = {
    off: 0,
    gold: 1,
    mirror: 2
};
const $a6d7bc8f2acef6fd$var$outputToneMappingOptions = {
    None: 'none',
    Reinhard: 'reinhard',
    ACES: 'aces'
};
const $a6d7bc8f2acef6fd$var$outputToneMappingValues = {
    none: 0,
    reinhard: 1,
    aces: 2
};
let $a6d7bc8f2acef6fd$var$cameraMoving = false;
const $a6d7bc8f2acef6fd$var$sceneCompiler = new (0, $0bec07c4e8263f03$export$af30c3d44590de39)();
$a6d7bc8f2acef6fd$var$init();
function $a6d7bc8f2acef6fd$var$modelHasAlbedoTexture(model) {
    let hasAlbedoTexture = false;
    model.traverse((child)=>{
        if (hasAlbedoTexture || !child.isMesh || !child.material) return;
        const materials = Array.isArray(child.material) ? child.material : [
            child.material
        ];
        hasAlbedoTexture = materials.some((material)=>Boolean(material?.map));
    });
    return hasAlbedoTexture;
}
function $a6d7bc8f2acef6fd$var$fitCameraToObject(object3D) {
    const box = new (0, $jw0R5.Box3)().setFromObject(object3D);
    const center = box.getCenter(new (0, $jw0R5.Vector3)());
    const size = box.getSize(new (0, $jw0R5.Vector3)());
    const maxSize = Math.max(size.x, size.y, size.z);
    const safeDistance = Math.max(maxSize * 1.8, 1.0);
    $a6d7bc8f2acef6fd$var$camera.position.set(center.x + safeDistance, center.y + safeDistance * 0.7, center.z + safeDistance);
    $a6d7bc8f2acef6fd$var$controls.target.copy(center);
    $a6d7bc8f2acef6fd$var$camera.near = Math.max(safeDistance / 100, 0.01);
    $a6d7bc8f2acef6fd$var$camera.far = Math.max(safeDistance * 20, 100);
    $a6d7bc8f2acef6fd$var$camera.updateProjectionMatrix();
    $a6d7bc8f2acef6fd$var$controls.update();
}
function $a6d7bc8f2acef6fd$var$applySelectedAlbedoTexture() {
    const hasOriginAlbedo = $a6d7bc8f2acef6fd$var$currentModelHasAlbedoTexture;
    if ($a6d7bc8f2acef6fd$var$materialParams.material === 'off' && !hasOriginAlbedo) {
        $a6d7bc8f2acef6fd$var$materialParams.material = 'gold';
        $a6d7bc8f2acef6fd$var$pane?.refresh();
    }
    const useOriginMaterial = $a6d7bc8f2acef6fd$var$materialParams.material === 'off' && hasOriginAlbedo;
    const materialPreset = useOriginMaterial ? $a6d7bc8f2acef6fd$var$materialPresetValues.off : $a6d7bc8f2acef6fd$var$materialPresetValues[$a6d7bc8f2acef6fd$var$materialParams.material];
    $a6d7bc8f2acef6fd$var$pathTracer.setMaterialPreset(materialPreset);
}
function $a6d7bc8f2acef6fd$var$applySelectedDebugMode() {
    const modeKey = $a6d7bc8f2acef6fd$var$materialParams.materialIndexing !== 'off' ? $a6d7bc8f2acef6fd$var$materialParams.materialIndexing : $a6d7bc8f2acef6fd$var$materialParams.debugMode;
    $a6d7bc8f2acef6fd$var$pathTracer.setDebugMode($a6d7bc8f2acef6fd$var$debugModeValues[modeKey]);
}
function $a6d7bc8f2acef6fd$var$applyOutputSettings() {
    $a6d7bc8f2acef6fd$var$pathTracer.setOutputToneMapping($a6d7bc8f2acef6fd$var$outputToneMappingValues[$a6d7bc8f2acef6fd$var$renderParams.toneMapping]);
    $a6d7bc8f2acef6fd$var$pathTracer.setOutputExposure($a6d7bc8f2acef6fd$var$renderParams.exposure);
}
function $a6d7bc8f2acef6fd$var$kickTraceFrame() {
    $a6d7bc8f2acef6fd$var$cameraMoving = false;
    if (!$a6d7bc8f2acef6fd$var$pathTracer.isReady()) {
        $a6d7bc8f2acef6fd$var$info.innerText = 'Samples: raster';
        return;
    }
    $a6d7bc8f2acef6fd$var$pathTracer.reset();
    $a6d7bc8f2acef6fd$var$pathTracer.update();
    $a6d7bc8f2acef6fd$var$info.innerText = `Samples: ${$a6d7bc8f2acef6fd$var$pathTracer.samples}`;
}
function $a6d7bc8f2acef6fd$var$clearResumeTraceTimer() {
    if ($a6d7bc8f2acef6fd$var$resumeTraceTimer !== null) {
        window.clearTimeout($a6d7bc8f2acef6fd$var$resumeTraceTimer);
        $a6d7bc8f2acef6fd$var$resumeTraceTimer = null;
    }
}
function $a6d7bc8f2acef6fd$var$scheduleTraceResume() {
    $a6d7bc8f2acef6fd$var$clearResumeTraceTimer();
    const delay = Math.max(0, $a6d7bc8f2acef6fd$var$renderParams.interactionResumeDelayMs | 0);
    if (delay === 0) {
        $a6d7bc8f2acef6fd$var$kickTraceFrame();
        return;
    }
    $a6d7bc8f2acef6fd$var$resumeTraceTimer = window.setTimeout(()=>{
        $a6d7bc8f2acef6fd$var$resumeTraceTimer = null;
        $a6d7bc8f2acef6fd$var$kickTraceFrame();
    }, delay);
}
function $a6d7bc8f2acef6fd$var$shouldUseRasterFallback() {
    if (!$a6d7bc8f2acef6fd$var$renderParams.rasterFallback) return false;
    return $a6d7bc8f2acef6fd$var$cameraMoving || !$a6d7bc8f2acef6fd$var$pathTracer.isReady();
}
function $a6d7bc8f2acef6fd$var$renderPathTracingFrame() {
    if ($a6d7bc8f2acef6fd$var$cameraMoving) $a6d7bc8f2acef6fd$var$pathTracer.reset();
    $a6d7bc8f2acef6fd$var$pathTracer.update();
    $a6d7bc8f2acef6fd$var$info.innerText = `Samples: ${$a6d7bc8f2acef6fd$var$pathTracer.samples}`;
}
function $a6d7bc8f2acef6fd$var$disposeSceneEnvironment() {
    if ($a6d7bc8f2acef6fd$var$currentEnvironmentBackground) {
        $a6d7bc8f2acef6fd$var$currentEnvironmentBackground.dispose();
        $a6d7bc8f2acef6fd$var$currentEnvironmentBackground = null;
    }
    if ($a6d7bc8f2acef6fd$var$currentEnvironmentTarget) {
        $a6d7bc8f2acef6fd$var$currentEnvironmentTarget.dispose();
        $a6d7bc8f2acef6fd$var$currentEnvironmentTarget = null;
    }
    $a6d7bc8f2acef6fd$var$scene.background = null;
    $a6d7bc8f2acef6fd$var$scene.environment = null;
}
function $a6d7bc8f2acef6fd$var$setSceneEnvironment(envTexture) {
    $a6d7bc8f2acef6fd$var$disposeSceneEnvironment();
    envTexture.mapping = (0, $jw0R5.EquirectangularReflectionMapping);
    $a6d7bc8f2acef6fd$var$currentEnvironmentBackground = envTexture;
    $a6d7bc8f2acef6fd$var$currentEnvironmentTarget = $a6d7bc8f2acef6fd$var$pmremGenerator.fromEquirectangular(envTexture);
    $a6d7bc8f2acef6fd$var$scene.background = $a6d7bc8f2acef6fd$var$currentEnvironmentBackground;
    $a6d7bc8f2acef6fd$var$scene.environment = $a6d7bc8f2acef6fd$var$currentEnvironmentTarget.texture;
}
async function $a6d7bc8f2acef6fd$var$loadSceneAssets() {
    const requestId = ++$a6d7bc8f2acef6fd$var$loadGeneration;
    $a6d7bc8f2acef6fd$var$pathTracer.setReady(false);
    const modelPath = $a6d7bc8f2acef6fd$var$modelAssetPaths[$a6d7bc8f2acef6fd$var$sceneParams.model];
    const modelUrl = modelPath.startsWith('http') ? modelPath : $a6d7bc8f2acef6fd$var$assetUrl + modelPath;
    const envUrl = $a6d7bc8f2acef6fd$var$assetUrl + $a6d7bc8f2acef6fd$var$hdrAssetPaths[$a6d7bc8f2acef6fd$var$sceneParams.environment];
    const [envTexture, gltf] = await Promise.all([
        new (0, $e3256e60e1337cbc$export$d076a711b55c758a)().loadAsync(envUrl),
        new (0, $ihXk0.GLTFLoader)().setMeshoptDecoder((0, $cf4be8bf96aa597d$export$1111800106ba519a)).loadAsync(modelUrl)
    ]);
    if (requestId !== $a6d7bc8f2acef6fd$var$loadGeneration) {
        envTexture.dispose();
        return;
    }
    if ($a6d7bc8f2acef6fd$var$currentModel) $a6d7bc8f2acef6fd$var$scene.remove($a6d7bc8f2acef6fd$var$currentModel);
    $a6d7bc8f2acef6fd$var$currentModel = gltf.scene;
    $a6d7bc8f2acef6fd$var$currentModelHasAlbedoTexture = $a6d7bc8f2acef6fd$var$modelHasAlbedoTexture($a6d7bc8f2acef6fd$var$currentModel);
    $a6d7bc8f2acef6fd$var$scene.add($a6d7bc8f2acef6fd$var$currentModel);
    $a6d7bc8f2acef6fd$var$fitCameraToObject($a6d7bc8f2acef6fd$var$currentModel);
    const compiledScene = $a6d7bc8f2acef6fd$var$sceneCompiler.compile($a6d7bc8f2acef6fd$var$currentModel);
    $a6d7bc8f2acef6fd$var$setSceneEnvironment(envTexture);
    $a6d7bc8f2acef6fd$var$pathTracer.setHdrTexture(envTexture);
    $a6d7bc8f2acef6fd$var$pathTracer.setScene(compiledScene);
    $a6d7bc8f2acef6fd$var$currentCompiledScene?.dispose();
    $a6d7bc8f2acef6fd$var$currentCompiledScene = compiledScene;
    $a6d7bc8f2acef6fd$var$applySelectedAlbedoTexture();
    $a6d7bc8f2acef6fd$var$applySelectedDebugMode();
    $a6d7bc8f2acef6fd$var$camera.updateProjectionMatrix();
    $a6d7bc8f2acef6fd$var$camera.updateMatrixWorld(true);
    $a6d7bc8f2acef6fd$var$controls.update();
    $a6d7bc8f2acef6fd$var$kickTraceFrame();
    requestAnimationFrame(()=>{
        if (requestId !== $a6d7bc8f2acef6fd$var$loadGeneration) return;
        $a6d7bc8f2acef6fd$var$kickTraceFrame();
    });
}
async function $a6d7bc8f2acef6fd$var$init() {
    $a6d7bc8f2acef6fd$var$renderer = new (0, $jw0R5.WebGLRenderer)({
        antialias: true
    });
    $a6d7bc8f2acef6fd$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $a6d7bc8f2acef6fd$var$renderer.setClearColor($a6d7bc8f2acef6fd$var$BG_COLOR, 1);
    $a6d7bc8f2acef6fd$var$renderer.setPixelRatio(1);
    $a6d7bc8f2acef6fd$var$renderer.autoClear = false;
    document.body.appendChild($a6d7bc8f2acef6fd$var$renderer.domElement);
    $a6d7bc8f2acef6fd$var$pmremGenerator = new (0, $jw0R5.PMREMGenerator)($a6d7bc8f2acef6fd$var$renderer);
    $a6d7bc8f2acef6fd$var$pmremGenerator.compileEquirectangularShader();
    const WIDTH = window.innerWidth;
    const HEIGHT = window.innerHeight;
    $a6d7bc8f2acef6fd$var$scene = new (0, $jw0R5.Scene)();
    $a6d7bc8f2acef6fd$var$camera = new (0, $jw0R5.PerspectiveCamera)(60, WIDTH / HEIGHT, 0.1, 10000);
    $a6d7bc8f2acef6fd$var$controls = new (0, $2sw9m.OrbitControls)($a6d7bc8f2acef6fd$var$camera, $a6d7bc8f2acef6fd$var$renderer.domElement);
    $a6d7bc8f2acef6fd$var$controls.target = new (0, $jw0R5.Vector3)(0, 0, 0);
    $a6d7bc8f2acef6fd$var$stats = new (0, $82VHk.default)();
    document.body.appendChild($a6d7bc8f2acef6fd$var$stats.dom);
    $a6d7bc8f2acef6fd$var$pathTracer = new (0, $bc45d8f57c09d163$export$85ed4a3796ccccf7)($a6d7bc8f2acef6fd$var$renderer, $a6d7bc8f2acef6fd$var$scene, $a6d7bc8f2acef6fd$var$camera);
    $a6d7bc8f2acef6fd$var$pathTracer.setRasterFallbackRenderer(({ renderer: fallbackRenderer, scene: fallbackScene, camera: fallbackCamera })=>{
        fallbackRenderer.setRenderTarget(null);
        fallbackRenderer.clear();
        fallbackRenderer.render(fallbackScene, fallbackCamera);
        $a6d7bc8f2acef6fd$var$info.innerText = 'Samples: raster';
    });
    $a6d7bc8f2acef6fd$var$pathTracer.setSize(WIDTH * $a6d7bc8f2acef6fd$var$renderParams.renderScale, HEIGHT * $a6d7bc8f2acef6fd$var$renderParams.renderScale);
    $a6d7bc8f2acef6fd$var$pathTracer.setBounce($a6d7bc8f2acef6fd$var$renderParams.bounceCount);
    $a6d7bc8f2acef6fd$var$pathTracer.setTransparentSteps($a6d7bc8f2acef6fd$var$renderParams.transparentSteps);
    $a6d7bc8f2acef6fd$var$applySelectedDebugMode();
    $a6d7bc8f2acef6fd$var$applyOutputSettings();
    $a6d7bc8f2acef6fd$var$initPane();
    await $a6d7bc8f2acef6fd$var$loadSceneAssets();
    $a6d7bc8f2acef6fd$var$event();
    $a6d7bc8f2acef6fd$var$animate();
}
function $a6d7bc8f2acef6fd$var$initPane() {
    $a6d7bc8f2acef6fd$var$pane = new (0, $ctZJO.Pane)({
        title: 'PathTracing'
    });
    const sceneFolder = $a6d7bc8f2acef6fd$var$pane.addFolder({
        title: 'Scene'
    });
    sceneFolder.addBinding($a6d7bc8f2acef6fd$var$sceneParams, 'model', {
        label: 'Model',
        options: $a6d7bc8f2acef6fd$var$modelOptions
    }).on('change', async ()=>{
        await $a6d7bc8f2acef6fd$var$loadSceneAssets();
    });
    sceneFolder.addBinding($a6d7bc8f2acef6fd$var$sceneParams, 'environment', {
        label: 'HDR',
        options: $a6d7bc8f2acef6fd$var$hdrOptions
    }).on('change', async ()=>{
        await $a6d7bc8f2acef6fd$var$loadSceneAssets();
    });
    const materialFolder = $a6d7bc8f2acef6fd$var$pane.addFolder({
        title: 'Material'
    });
    materialFolder.addBinding($a6d7bc8f2acef6fd$var$materialParams, 'material', {
        label: 'Preset',
        options: $a6d7bc8f2acef6fd$var$materialOptions
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$applySelectedAlbedoTexture();
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    const renderFolder = $a6d7bc8f2acef6fd$var$pane.addFolder({
        title: 'Render'
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'bounceCount', {
        label: 'Bounces',
        min: 1,
        max: 8,
        step: 1
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$pathTracer.setBounce($a6d7bc8f2acef6fd$var$renderParams.bounceCount);
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'transparentSteps', {
        label: 'Trans Steps',
        min: 1,
        max: 8,
        step: 1
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$pathTracer.setTransparentSteps($a6d7bc8f2acef6fd$var$renderParams.transparentSteps);
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'rasterFallback', {
        label: 'Raster Fallback'
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'interactionResumeDelayMs', {
        label: 'Resume Delay',
        min: 0,
        max: 1000,
        step: 10
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'toneMapping', {
        label: 'Tone Map',
        options: $a6d7bc8f2acef6fd$var$outputToneMappingOptions
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$applyOutputSettings();
    });
    renderFolder.addBinding($a6d7bc8f2acef6fd$var$renderParams, 'exposure', {
        label: 'Exposure',
        min: 0.1,
        max: 3.0,
        step: 0.05
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$applyOutputSettings();
    });
    const debugFolder = $a6d7bc8f2acef6fd$var$pane.addFolder({
        title: 'Debug'
    });
    debugFolder.addBinding($a6d7bc8f2acef6fd$var$materialParams, 'debugMode', {
        label: 'UV',
        options: $a6d7bc8f2acef6fd$var$debugModeOptions
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$applySelectedDebugMode();
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    debugFolder.addBinding($a6d7bc8f2acef6fd$var$materialParams, 'materialIndexing', {
        label: 'Indexing',
        options: $a6d7bc8f2acef6fd$var$materialIndexingOptions
    }).on('change', ()=>{
        $a6d7bc8f2acef6fd$var$applySelectedDebugMode();
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
}
function $a6d7bc8f2acef6fd$var$event() {
    window.addEventListener('resize', ()=>{
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        $a6d7bc8f2acef6fd$var$pathTracer.camera.aspect = innerWidth / innerHeight;
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
        $a6d7bc8f2acef6fd$var$pathTracer.setSize(innerWidth * $a6d7bc8f2acef6fd$var$renderParams.renderScale, innerHeight * $a6d7bc8f2acef6fd$var$renderParams.renderScale);
        $a6d7bc8f2acef6fd$var$pathTracer.update();
    });
    window.addEventListener('beforeunload', ()=>{
        $a6d7bc8f2acef6fd$var$clearResumeTraceTimer();
        $a6d7bc8f2acef6fd$var$pathTracer.dispose();
        $a6d7bc8f2acef6fd$var$currentCompiledScene?.dispose();
        $a6d7bc8f2acef6fd$var$disposeSceneEnvironment();
        $a6d7bc8f2acef6fd$var$pmremGenerator.dispose();
    });
    $a6d7bc8f2acef6fd$var$controls.addEventListener('start', ()=>{
        $a6d7bc8f2acef6fd$var$clearResumeTraceTimer();
        $a6d7bc8f2acef6fd$var$cameraMoving = true;
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    $a6d7bc8f2acef6fd$var$controls.addEventListener('change', ()=>{
        $a6d7bc8f2acef6fd$var$clearResumeTraceTimer();
        $a6d7bc8f2acef6fd$var$cameraMoving = true;
        $a6d7bc8f2acef6fd$var$pathTracer.reset();
    });
    $a6d7bc8f2acef6fd$var$controls.addEventListener('end', ()=>{
        $a6d7bc8f2acef6fd$var$scheduleTraceResume();
    });
}
function $a6d7bc8f2acef6fd$var$animate() {
    requestAnimationFrame($a6d7bc8f2acef6fd$var$animate);
    $a6d7bc8f2acef6fd$var$stats.update();
    $a6d7bc8f2acef6fd$var$controls.update();
    if ($a6d7bc8f2acef6fd$var$shouldUseRasterFallback()) {
        $a6d7bc8f2acef6fd$var$pathTracer.renderRasterFallback();
        return;
    }
    $a6d7bc8f2acef6fd$var$renderPathTracingFrame();
}


//# sourceMappingURL=pathTracing.8770fbd1.js.map
